import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {
    CssBaseline, CircularProgress, Container, Button, Grid, Divider,
    Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip,
    TextField, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Chip
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import RefreshIcon from '@material-ui/icons/Refresh';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import BlockIcon from '@material-ui/icons/Block';
import SaveIcon from '@material-ui/icons/Save';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import { ContractStatusBadge, SubscriptionStatusBadge, PaymentStatusBadge, ProvisioningStatusBadge } from '../../components/status-badge';
import PaymentIcon from '@material-ui/icons/Payment';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ConvertPlanDialog from '../../components/convert-plan-dialog';
import ConfirmActionDialog from '../../components/confirm-action-dialog';
import DangerConfirmDialog from '../../components/danger-confirm-dialog';
import DeprovisioningBanner from '../../components/deprovisioning-banner';
import ForceDropConfirmDialog from '../../components/force-drop-confirm-dialog';
import StatusHistoryTable from '../../components/status-history-table';
import HirerCredentialsCard from '../../components/hirer-credentials-card';
import ProvisioningErrorBanner from '../../components/provisioning-error-banner';
import ProvisioningDetailPanel from '../../components/provisioning-detail-panel';
import SectionCard from '../../components/section-card';
import AddProductWizard from '../../components/add-product-wizard';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import * as adminProductService from '../../services/admin-product.service';
import * as adminInvoiceService from '../../services/admin-invoice.service';
import Api from "../../services/api";

const CONTRACT_STATUSES = [
    { id: 1, name: 'Solicitado' },
    { id: 2, name: 'Vigente' },
    { id: 3, name: 'Encerrado' },
    { id: 4, name: 'Cancelado' },
    { id: 5, name: 'Em Trial' },
    { id: 6, name: 'Suspenso' },
    { id: 7, name: 'Expirado' },
    { id: 8, name: 'Aguardando Pagamento' },
];

class AdminSubscriptionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            detail: null,
            tabValue: 0,
            invoices: [],
            payments: [],
            history: [],
            paymentMethods: [],
            loadingPaymentMethods: false,
            usage: [],
            creditBalances: [],
            creditTransactions: [],
            creditPurchaseAmount: '',
            creditPurchaseLoading: false,
            creditPurchaseCppId: null,
            creditPurchaseConfirmOpen: false,
            creditPurchaseConfirmCppId: null,
            creditPaymentMethods: [],
            creditSelectedPaymentMethodId: '',
            contractProducts: [],
            removeProductId: null,
            removeProductDialogOpen: false,
            convertDialogOpen: false,
            blockDialogOpen: false,
            addProductDialogOpen: false,
            createSubscriptionDialogOpen: false,
            creatingSubscription: false,
            dangerDialogOpen: false,
            dangerLoading: false,
            dangerSendingCode: false,
            dangerCodeSentState: null,
            deprovisioningStatus: null,
            aborting: false,
            forceDropDialogOpen: false,
            forceDropSending: false,
            forceDropSubmitting: false,
            forceDropCodeSentState: null,
            statusHistory: [],
            statusHistoryLoading: false,
            abortConfirmOpen: false,
            abortDropConfirmOpen: false,
            // Payment Gateway
            paymentGateways: [],
            editGatewayId: '',
            savingGateway: false,
            // Manual Invoice Dialog
            createInvoiceDialogOpen: false,
            markPaidDialogOpen: false,
            markPaidInvoiceId: null,
            cancelInvoiceDialogOpen: false,
            cancelInvoiceId: null,
            invoicePaymentMethods: [],
            newInvoice: {
                value: '',
                monthReference: new Date().getMonth() + 1,
                yearReference: new Date().getFullYear(),
                dueDate: '',
                paymentMethodId: '',
                discountValue: '',
                interestValue: '',
                fineValue: '',
            },
            // Editable fields
            editStatusId: '',
            editPeriodEnd: '',
            editPlanPrice: '',
            editPlanValue: '',
            editAgentLimit: '',
            editDiskLimit: '',
            editAttendanceLimit: '',
            editAdditionalValueAgent: '',
            editAttendanceValue: '',
            editQuantity: '',
            editDiskOverageValue: '',
            editBillingMode: 'unit',
            editCreditAmountMonthly: '',
            editCreditAlertThreshold: '',
            editCreditAutoRechargeEnabled: false,
            editCreditAutoRechargeAmount: '',
            editCreditAutoRechargeTrigger: '',
            selectedProductForEdit: null,
            selectedProductAllowedModes: [1, 2],
            billingModes: [],
            loadingProductEdit: false,
            savingStatus: false,
            savingPeriodEnd: false,
            savingLimits: false,
            // Convert to trial
            convertToTrialDialogOpen: false,
            // Switch product plan
            selectedProductForSwitch: null,
            switchPlanDialogOpen: false,
            switchPlanStep: 0,
            switchPlans: [],
            switchPeriodicities: [],
            switchSelectedPlanId: null,
            switchSelectedPpId: null,
            switchPlansLoading: false,
            switchPeriodicitiesLoading: false,
            trialDays: 14,
            hirerConfig: null,
            _hirerConfigLoaded: false,
            // Provisioning
            provisioningConfirmDialog: { open: false, title: '', message: '', action: null },
            // Tamanho da empresa (catálogo)
            companySizes: [],
            companySizeDialogOpen: false,
            companySizeDialogValue: '',
            companySizeSaving: false,
        };
        this.closeNotification = this.closeNotification.bind(this);
    }

    componentDidMount() {
        const { currentHirer } = this.props;
        if (!currentHirer || !currentHirer.hirerid) {
            this.props.history.push(`/${this.props.match.params.lang}/admin-subscriptions`);
            return;
        }
        this.loadDetail(currentHirer.hirerid);
        this.loadContractProducts(currentHirer.hirerid);
        this.loadPaymentGateways();
        this.loadBillingModes();
        this.loadCompanySizes();
    }

    loadCompanySizes = () => {
        adminBillingService.getCompanySizes()
            .then(r => {
                const sizes = r.data.success ? (r.data.data || []) : [];
                this.setState({ companySizes: sizes });
            })
            .catch(() => {});
    }

    openCompanySizeDialog = () => {
        this.setState({
            companySizeDialogOpen: true,
            companySizeDialogValue: this.state.detail?.companysizeid ? String(this.state.detail.companysizeid) : '',
        });
    }

    closeCompanySizeDialog = () => {
        this.setState({ companySizeDialogOpen: false });
    }

    handleSaveCompanySize = () => {
        const { detail, companySizeDialogValue } = this.state;
        const intl = this.props.intl;
        if (!detail?.hirerid) return;
        const companySizeId = companySizeDialogValue ? parseInt(companySizeDialogValue) : null;
        this.setState({ companySizeSaving: true });
        adminBillingService.updateHirerCompanySize(detail.hirerid, companySizeId)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        companySizeSaving: false,
                        companySizeDialogOpen: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({ id: "admin.hirer.company_size.update.success" })
                    });
                    this.loadDetail(detail.hirerid);
                } else {
                    this.setState({
                        companySizeSaving: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data.errors?.[0] || intl.formatMessage({ id: "admin.hirer.company_size.update.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    companySizeSaving: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.response?.data?.errors?.[0] || intl.formatMessage({ id: "admin.hirer.company_size.update.error" })
                });
                Api.kickoff(err);
            });
    }

    // Handlers de refresh por aba (cada aba chama apenas os endpoints pertinentes).
    refreshSummaryTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadDetail(detail.hirerid);
        this.loadContractProducts(detail.hirerid);
    }
    refreshInvoicesTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadInvoices(detail.hirerid);
    }
    refreshPaymentsTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadPayments(detail.hirerid);
    }
    refreshHistoryTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadHistory(detail.hirerid);
    }
    refreshPaymentMethodsTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadPaymentMethods(detail.hirerid);
    }
    refreshUsageTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadUsage(detail.hirerid);
    }
    refreshCreditsTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadCredits(detail.hirerid);
    }
    refreshHirerConfigTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadDetail(detail.hirerid);
        this.loadHirerConfig();
    }
    refreshStatusHistoryTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadStatusHistory(detail.hirerid);
    }

    renderRefreshAction = (handler, disabled) => (
        <Tooltip title="Atualizar">
            <span>
                <IconButton size="small" onClick={handler} disabled={disabled}>
                    <RefreshIcon />
                </IconButton>
            </span>
        </Tooltip>
    );

    loadDetail(hirerId) {
        this.setState({ loading: true });
        adminBillingService.getHirerDetail(hirerId)
            .then(result => {
                if (result.data.success) {
                    const detail = result.data.data;
                    // Trial (status_id=5) → trial_end_date. Assinatura → end_date (preferencial)
                    // ou current_period_end (fallback) caso a coluna ainda não esteja preenchida.
                    const isTrial = detail.contractstatusid === 5;
                    const periodEnd = isTrial
                        ? (detail.trialenddate || detail.enddate || detail.currentperiodend)
                        : (detail.enddate || detail.currentperiodend || detail.trialenddate);
                    this.setState({
                        loading: false,
                        detail,
                        editStatusId: detail.contractstatusid || '',
                        editPeriodEnd: periodEnd ? periodEnd.substring(0, 10) : '',
                        editPlanPrice: '',
                        editPlanValue: '',
                        editAgentLimit: '',
                        editDiskLimit: '',
                        editAttendanceLimit: '',
                        editAdditionalValueAgent: '',
                        editAttendanceValue: '',
                        editVoipMinutesLimit: '',
                        editVoipMinuteValue: '',
                        editQuantity: '',
                        selectedProductForEdit: null,
                        editGatewayId: detail.paymentgatewayid || '',
                    });
                    // Agora que temos detail.contractid, podemos buscar o status de deprovisionamento.
                    const contractId = detail?.contractid;
                    if (contractId) {
                        this.loadDeprovisioningStatus(hirerId, contractId);
                    } else {
                        console.warn('[admin-subscription-detail] contractid ausente no detail — skipping loadDeprovisioningStatus');
                        this.setState({ deprovisioningStatus: null });
                    }
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    loadInvoices(hirerId) {
        this.setState({ loading: true });
        adminBillingService.getHirerInvoices(hirerId, 50, 0)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, invoices: result.data.data || [] });
                } else {
                    this.setState({ loading: false, invoices: [] });
                }
            })
            .catch(() => this.setState({ loading: false, invoices: [] }));
    }

    loadPayments(hirerId) {
        this.setState({ loading: true });
        adminBillingService.getHirerPayments(hirerId, 50, 0)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, payments: result.data.data || [] });
                } else {
                    this.setState({ loading: false, payments: [] });
                }
            })
            .catch(() => this.setState({ loading: false, payments: [] }));
    }

    loadHistory(hirerId) {
        this.setState({ loading: true });
        adminBillingService.getHirerHistory(hirerId, 50, 0)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, history: result.data.data || [] });
                } else {
                    this.setState({ loading: false, history: [] });
                }
            })
            .catch(() => this.setState({ loading: false, history: [] }));
    }

    showError(message) {
        const intl = this.props.intl;
        this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: message || intl.formatMessage({ id: "process.error" })
        });
    }

    showSuccess(message) {
        this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: message
        });
    }

    handleTabChange = (e, newValue) => {
        this.setState({ tabValue: newValue });
        const hirerId = this.state.detail ? this.state.detail.hirerid : this.props.currentHirer.hirerid;
        if (newValue === 1 && this.state.invoices.length === 0) this.loadInvoices(hirerId);
        if (newValue === 2 && this.state.payments.length === 0) this.loadPayments(hirerId);
        if (newValue === 3 && this.state.history.length === 0) this.loadHistory(hirerId);
        if (newValue === 4 && this.state.paymentMethods.length === 0) this.loadPaymentMethods(hirerId);
        if (newValue === 5 && this.state.usage.length === 0) this.loadUsage(hirerId);
        if (newValue === 6 && this.state.creditBalances.length === 0) this.loadCredits(hirerId);
        if (newValue === 9) this.loadStatusHistory(hirerId);
    }

    loadCredits(hirerId) {
        this.setState({ loading: true });
        Promise.all([
            adminBillingService.getCreditBalances(hirerId),
            adminBillingService.getCreditTransactions(hirerId)
        ]).then(([balancesResult, transactionsResult]) => {
            this.setState({
                loading: false,
                creditBalances: balancesResult.data.success ? (balancesResult.data.data || []) : [],
                creditTransactions: transactionsResult.data.success ? (transactionsResult.data.data || []) : []
            });
        }).catch(() => this.setState({ loading: false, creditBalances: [], creditTransactions: [] }));
    }

    handleAdminPurchaseCredits = () => {
        const { detail, creditPurchaseConfirmCppId, creditSelectedPaymentMethodId } = this.state;
        const intl = this.props.intl;
        const amount = parseFloat(this.state.creditPurchaseAmount);
        if (!amount || amount <= 0) return;

        const paymentMethodId = creditSelectedPaymentMethodId ? parseInt(creditSelectedPaymentMethodId) : null;
        this.setState({ creditPurchaseLoading: true, creditPurchaseConfirmOpen: false });
        adminBillingService.purchaseCredits(detail.hirerid, creditPurchaseConfirmCppId, amount, paymentMethodId)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.credits.purchase.success" }));
                    this.setState({ creditPurchaseLoading: false, creditPurchaseAmount: '', creditPurchaseCppId: null });
                    this.loadCredits(detail.hirerid);
                } else {
                    this.setState({ creditPurchaseLoading: false });
                    this.showError(result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" }));
                }
            })
            .catch(err => {
                this.setState({ creditPurchaseLoading: false });
                this.showError(err.response?.data?.errors?.[0] ?? intl.formatMessage({ id: "process.error" }));
                Api.kickoff(err);
            });
    }

    loadPaymentMethods(hirerId) {
        this.setState({ loadingPaymentMethods: true });
        adminBillingService.getHirerPaymentMethods(hirerId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ paymentMethods: result.data.data || [], loadingPaymentMethods: false });
                } else {
                    this.setState({ loadingPaymentMethods: false });
                }
            })
            .catch(err => {
                this.setState({ loadingPaymentMethods: false });
                Api.kickoff(err);
            });
    }

    loadUsage(hirerId) {
        this.setState({ loading: true });
        adminBillingService.getHirerUsage(hirerId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, usage: result.data.data || [] });
                } else {
                    this.setState({ loading: false, usage: [] });
                }
            })
            .catch(() => this.setState({ loading: false, usage: [] }));
    }

    loadContractProducts(hirerId) {
        adminBillingService.getContractProducts(hirerId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ contractProducts: result.data.data || [] });
                } else {
                    this.setState({ contractProducts: [] });
                }
            })
            .catch(() => this.setState({ contractProducts: [] }));
    }

    loadBillingModes() {
        adminProductService.getBillingModes()
            .then(result => {
                if (result.data.success) this.setState({ billingModes: result.data.data || [] });
            })
            .catch(() => {});
    }

    loadAllowedBillingModes(applicationId) {
        adminProductService.getAllowedBillingModes(applicationId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ selectedProductAllowedModes: result.data.data || [1, 2] });
                }
            })
            .catch(() => {});
    }

    loadPaymentGateways() {
        adminBillingService.getPaymentGateways()
            .then(result => {
                if (result.data.success) {
                    this.setState({ paymentGateways: result.data.data || [] });
                } else {
                    this.setState({ paymentGateways: [] });
                }
            })
            .catch(() => this.setState({ paymentGateways: [] }));
    }

    handleSaveGateway = () => {
        const { detail, editGatewayId } = this.state;
        const intl = this.props.intl;

        if (!editGatewayId || editGatewayId <= 0) {
            this.setState({
                openNotification: true, notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "admin.gateway.select.required" })
            });
            return;
        }

        if (!detail?.contractid) {
            this.showError(intl.formatMessage({ id: "process.error" }));
            return;
        }

        this.setState({ savingGateway: true });
        adminBillingService.updateContractGateway(detail.hirerid, detail.contractid, parseInt(editGatewayId))
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        savingGateway: false,
                        openNotification: true, notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({ id: "admin.gateway.update.success" })
                    });
                    this.loadDetail(detail.hirerid);
                } else {
                    this.setState({
                        savingGateway: false,
                        openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    savingGateway: false,
                    openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    handleOpenCreateInvoice = () => {
        this.setState({ createInvoiceDialogOpen: true });
        adminInvoiceService.getPaymentMethods()
            .then(result => {
                if (result.data.success) {
                    this.setState({ invoicePaymentMethods: result.data.data || [] });
                }
            })
            .catch(() => {});
    }

    handleCreateInvoice = () => {
        const { detail, newInvoice } = this.state;
        const intl = this.props.intl;

        if (!newInvoice.value || parseFloat(newInvoice.value) <= 0) {
            this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: intl.formatMessage({ id: "admin.invoice.manual.value.required" }) });
            return;
        }
        if (!newInvoice.dueDate) {
            this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: intl.formatMessage({ id: "admin.invoice.manual.due.required" }) });
            return;
        }

        this.setState({ createInvoiceDialogOpen: false, loading: true });

        adminInvoiceService.createManualInvoice({
            hirerId: detail.hirerid,
            value: parseFloat(newInvoice.value),
            monthReference: parseInt(newInvoice.monthReference),
            yearReference: parseInt(newInvoice.yearReference),
            dueDate: newInvoice.dueDate,
            paymentMethodId: newInvoice.paymentMethodId ? parseInt(newInvoice.paymentMethodId) : null,
            discountValue: newInvoice.discountValue ? parseFloat(newInvoice.discountValue) : null,
            interestValue: newInvoice.interestValue ? parseFloat(newInvoice.interestValue) : null,
            fineValue: newInvoice.fineValue ? parseFloat(newInvoice.fineValue) : null,
        })
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.invoice.manual.create.success" }));
                    this.loadInvoices(detail.hirerid);
                    this.setState({
                        newInvoice: { value: '', monthReference: new Date().getMonth() + 1, yearReference: new Date().getFullYear(), dueDate: '', paymentMethodId: '', discountValue: '', interestValue: '', fineValue: '' }
                    });
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleMarkInvoicePaid = () => {
        const { detail, markPaidInvoiceId } = this.state;
        const intl = this.props.intl;
        this.setState({ markPaidDialogOpen: false, loading: true });

        adminInvoiceService.markInvoiceAsPaid(markPaidInvoiceId)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.invoice.manual.paid.success" }));
                    this.loadInvoices(detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleCancelInvoice = () => {
        const { detail, cancelInvoiceId } = this.state;
        const intl = this.props.intl;
        this.setState({ cancelInvoiceDialogOpen: false, loading: true });

        adminInvoiceService.cancelInvoice(cancelInvoiceId)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.invoice.manual.cancel.success" }));
                    this.loadInvoices(detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    getUsageTypeLabel(usageType) {
        const labels = {
            'agent': 'Agentes',
            'attendance': 'Atendimentos/mês',
            'disk_mb': 'Disco (MB)',
            'whatsapp_message': 'Mensagens WhatsApp/mês',
        };
        return labels[usageType] || usageType;
    }

    handleBlockConfirm = () => {
        const { detail } = this.state;
        const intl = this.props.intl;
        this.setState({ blockDialogOpen: false, loading: true });

        adminBillingService.blockHirer(detail.hirerid, 'admin')
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.block.success" }));
                    this.loadDetail(detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleAddProductConfirm = (productData) => {
        const { detail } = this.state;
        const intl = this.props.intl;
        this.setState({ loading: true });

        adminBillingService.addProductToContract(detail.hirerid, {
            applicationId: productData.applicationId,
            planPeriodicityId: productData.planPeriodicityId,
            planValuePerMonth: productData.planValuePerMonth || 0,
            planValue: productData.planValue || 0,
            agentLimitQuantity: productData.agentLimitQuantity,
            diskLimitUsage: productData.diskLimitUsage,
            attendanceLimitPerMonth: productData.attendanceLimitPerMonth,
            additionalValueAgent: productData.additionalValueAgent,
            attendanceValue: productData.attendanceValue,
            diskOverageValue: productData.diskOverageValue,
            billingMode: productData.billingMode,
            creditAmountMonthly: productData.creditAmountMonthly,
            creditAlertThreshold: productData.creditAlertThreshold,
            creditAutoRechargeEnabled: productData.creditAutoRechargeEnabled,
            creditAutoRechargeAmount: productData.creditAutoRechargeAmount,
            creditAutoRechargeTrigger: productData.creditAutoRechargeTrigger,
            quantity: productData.quantity || 1,
        })
            .then(result => {
                if (result.data.success) {
                    this.setState({ addProductDialogOpen: false });
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.add.product.success" }));
                    this.loadDetail(detail.hirerid);
                    this.loadContractProducts(detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleRemoveProductConfirm = () => {
        const { detail, removeProductId } = this.state;
        const intl = this.props.intl;
        this.setState({ removeProductDialogOpen: false, loading: true });

        adminBillingService.removeProductFromContract(detail.hirerid, removeProductId)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.contract.products.remove.success" }));
                    this.loadDetail(detail.hirerid);
                    this.loadContractProducts(detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleUnblock = () => {
        const { detail } = this.state;
        const intl = this.props.intl;
        this.setState({ loading: true });

        adminBillingService.unblockHirer(detail.hirerid)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.unblock.success" }));
                    this.loadDetail(detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleConvert = () => {
        this.setState({ convertDialogOpen: true });
    }

    handleConvertConfirm = (planPeriodicityId) => {
        const { detail } = this.state;
        const intl = this.props.intl;
        this.setState({ convertDialogOpen: false, loading: true });

        adminBillingService.convertTrial(detail.hirerid, { planPeriodicityId })
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.convert.success" }));
                    this.loadDetail(detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleRetryPayment = (paymentId) => {
        const intl = this.props.intl;
        this.setState({ loading: true });

        adminBillingService.retryPayment(paymentId)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.billing.retry.success" }));
                    this.loadPayments(this.state.detail.hirerid);
                } else {
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleSyncPayments = () => {
        const { detail } = this.state;
        this.setState({ loading: true });
        adminBillingService.syncPayments(detail.hirerid)
            .then(result => {
                if (result.data.success) {
                    const synced = result.data.data?.synced ?? 0;
                    this.showSuccess(`${synced} pagamento(s) sincronizado(s) do gateway.`);
                    this.loadPayments(detail.hirerid);
                } else { this.showError(result.data.errors?.[0] || 'Erro ao sincronizar'); }
                this.setState({ loading: false });
            })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); this.setState({ loading: false }); Api.kickoff(err); });
    }

    handleChargeSubscription = () => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.openProvisioningConfirm('Cobrar Assinatura', 'Deseja cobrar todas as invoices pendentes desta assinatura? Se nao houver invoices abertas, uma nova sera gerada e cobrada.', () => {
            this.setState({ loading: true, provisioningConfirmDialog: { open: false } });
            adminBillingService.chargeSubscription(detail.hirerid, detail.contractid)
                .then(result => {
                    if (result.data.success) { this.showSuccess('Cobranca realizada com sucesso!'); this.loadPayments(detail.hirerid); }
                    else { this.showError(result.data.errors?.[0] || 'Erro ao cobrar'); }
                    this.setState({ loading: false });
                })
                .catch(err => { this.showError(err.response?.data?.errors?.[0]); this.setState({ loading: false }); Api.kickoff(err); });
        });
    }

    handleVoidPayment = (paymentId) => {
        const { detail } = this.state;
        this.openProvisioningConfirm('Excluir Pagamento', 'Deseja excluir este pagamento? A invoice sera anulada no gateway e o registro removido localmente.', () => {
            this.setState({ loading: true, provisioningConfirmDialog: { open: false } });
            adminBillingService.voidPayment(detail.hirerid, paymentId)
                .then(result => {
                    if (result.data.success) { this.showSuccess('Pagamento excluido com sucesso!'); this.loadPayments(detail.hirerid); }
                    else { this.showError(result.data.errors?.[0] || 'Erro ao excluir'); }
                    this.setState({ loading: false });
                })
                .catch(err => { this.showError(err.response?.data?.errors?.[0]); this.setState({ loading: false }); Api.kickoff(err); });
        });
    }

    handleSendScheduleDeprovCode = ({ email }) => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.setState({ dangerSendingCode: true });
        adminBillingService.sendScheduleDeprovTwoFactorCode(detail.hirerid, email)
            .then(result => {
                if (result.data.success) {
                    this.setState({ dangerSendingCode: false, dangerCodeSentState: { ...result.data.data, sent: true } });
                } else {
                    this.setState({ dangerSendingCode: false, dangerCodeSentState: { sent: false, errormessage: result.data.errors?.[0] || 'Falha ao enviar código' } });
                }
            })
            .catch(err => { this.setState({ dangerSendingCode: false, dangerCodeSentState: { sent: false, errormessage: 'Falha ao enviar código' } }); Api.kickoff(err); });
    }

    handleScheduleDeprovisioning = ({ reason, confirmWorkspace, twoFactorCode }) => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ dangerLoading: true });
        adminBillingService.scheduleSubscriptionDeprovisioning(detail.hirerid, detail.contractid, { reason, confirmWorkspace, twoFactorCode })
            .then(result => {
                if (result.data.success) {
                    this.setState({ dangerLoading: false, dangerDialogOpen: false, dangerCodeSentState: null });
                    this.showSuccess('Desprovisionamento agendado. O ambiente será removido após o período de carência.');
                    // Backend altera contract_status_id + tb_provisioning_queue.status. UI precisa
                    // recarregar tudo: detail (status do contrato, badges) + deprovisioningStatus (banner).
                    this.loadDetail(detail.hirerid);
                    this.loadDeprovisioningStatus(detail.hirerid, detail.contractid);
                } else {
                    this.setState({ dangerLoading: false });
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.setState({ dangerLoading: false }); this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    loadDeprovisioningStatus(hirerId, contractId) {
        if (!contractId) {
            console.warn('[admin-subscription-detail] loadDeprovisioningStatus chamado sem contractId');
            this.setState({ deprovisioningStatus: null });
            return;
        }
        adminBillingService.getDeprovisioningStatus(hirerId, contractId)
            .then(result => {
                this.setState({ deprovisioningStatus: result.data.success ? result.data.data : null });
            })
            .catch(() => this.setState({ deprovisioningStatus: null }));
    }

    loadStatusHistory = (hirerId) => {
        this.setState({ statusHistoryLoading: true });
        adminBillingService.getContractStatusHistory(hirerId, 100, 0)
            .then(result => {
                this.setState({
                    statusHistoryLoading: false,
                    statusHistory: result.data.success ? (result.data.data || []) : [],
                });
            })
            .catch(() => this.setState({ statusHistoryLoading: false, statusHistory: [] }));
    }

    // Abre confirm dialog antes de executar abort.
    handleAbortDeprovisioning = () => this.setState({ abortConfirmOpen: true });
    handleAbortDatabaseDrop = () => this.setState({ abortDropConfirmOpen: true });

    confirmAbortDeprovisioning = () => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ aborting: true, abortConfirmOpen: false });
        adminBillingService.abortSubscriptionDeprovisioning(detail.hirerid, detail.contractid)
            .then(result => {
                this.setState({ aborting: false });
                if (result.data.success) {
                    this.showSuccess('Desprovisionamento abortado com sucesso.');
                    this.loadDetail(detail.hirerid);
                } else {
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.setState({ aborting: false }); this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    confirmAbortDatabaseDrop = () => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ aborting: true, abortDropConfirmOpen: false });
        adminBillingService.abortDatabaseDrop(detail.hirerid, detail.contractid)
            .then(result => {
                this.setState({ aborting: false });
                if (result.data.success) {
                    this.showSuccess('Deleção do banco de dados abortada com sucesso.');
                    this.loadDetail(detail.hirerid);
                } else {
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.setState({ aborting: false }); this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    openForceDropDialog = () => {
        this.setState({ forceDropDialogOpen: true, forceDropCodeSentState: null, forceDropError: null });
    }

    closeForceDropDialog = () => {
        this.setState({ forceDropDialogOpen: false, forceDropCodeSentState: null });
    }

    handleSendForceDropCode = ({ email }) => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.setState({ forceDropSending: true });
        adminBillingService.sendForceDropTwoFactorCode(detail.hirerid, email)
            .then(result => {
                this.setState({ forceDropSending: false });
                if (result.data.success) {
                    this.setState({ forceDropCodeSentState: result.data.data });
                } else {
                    this.setState({ forceDropCodeSentState: { sent: false, errormessage: result.data.errors?.[0] || 'Falha ao enviar código' } });
                }
            })
            .catch(err => {
                this.setState({ forceDropSending: false, forceDropCodeSentState: { sent: false, errormessage: err.response?.data?.errors?.[0] || 'Erro inesperado' } });
                Api.kickoff(err);
            });
    }

    handleForceDatabaseDrop = (payload) => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ forceDropSubmitting: true, forceDropError: null });
        adminBillingService.forceDatabaseDrop(detail.hirerid, detail.contractid, payload)
            .then(result => {
                if (result.data.success) {
                    this.setState({ forceDropSubmitting: false, forceDropDialogOpen: false, forceDropCodeSentState: null, forceDropError: null });
                    this.showSuccess('Drop imediato executado. Aguardando confirmação no background.');
                    this.loadDeprovisioningStatus(detail.hirerid, detail.contractid);
                } else {
                    const msg = result.data.errors?.[0] || 'Falha ao forçar drop';
                    this.setState({ forceDropSubmitting: false, forceDropError: msg });
                }
            })
            .catch(err => {
                const msg = err.response?.data?.errors?.[0] || 'Falha ao forçar drop';
                this.setState({ forceDropSubmitting: false, forceDropError: msg });
                Api.kickoff(err);
            });
    }

    handleCreateSubscription = () => {
        const { detail } = this.state;
        const intl = this.props.intl;
        const planPeriodicityId = detail.planperiodicityid;

        if (!planPeriodicityId) {
            this.showError(intl.formatMessage({ id: "admin.subscription.no.plan.periodicity" }));
            return;
        }

        if (!detail?.contractid) {
            this.showError(intl.formatMessage({ id: "process.error" }));
            return;
        }

        this.setState({ creatingSubscription: true, loading: true });

        adminBillingService.createStripeSubscription(detail.hirerid, detail.contractid, planPeriodicityId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ creatingSubscription: false });
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.create.gateway.success" }));
                    this.loadDetail(detail.hirerid);
                } else {
                    this.setState({ creatingSubscription: false });
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.setState({ creatingSubscription: false });
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleSaveStatus = () => {
        const { detail, editStatusId } = this.state;
        const intl = this.props.intl;

        if (!editStatusId || editStatusId === detail.contractstatusid) return;
        if (!detail?.contractid) {
            this.showError(intl.formatMessage({ id: "process.error" }));
            return;
        }

        this.setState({ savingStatus: true });
        adminBillingService.updateContractStatus(detail.hirerid, detail.contractid, editStatusId)
            .then(result => {
                if (result.data.success) {
                    this.setState({ savingStatus: false });
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.status.updated" }));
                    this.loadDetail(detail.hirerid);
                } else {
                    this.setState({ savingStatus: false });
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.setState({ savingStatus: false });
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleSavePeriodEnd = () => {
        const { detail, editPeriodEnd } = this.state;
        const intl = this.props.intl;

        if (!editPeriodEnd) return;
        if (!detail?.contractid) {
            this.showError(intl.formatMessage({ id: "process.error" }));
            return;
        }

        this.setState({ savingPeriodEnd: true });
        adminBillingService.updateContractPeriodEnd(detail.hirerid, detail.contractid, editPeriodEnd)
            .then(result => {
                if (result.data.success) {
                    this.setState({ savingPeriodEnd: false });
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.period.updated" }));
                    this.loadDetail(detail.hirerid);
                } else {
                    this.setState({ savingPeriodEnd: false });
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.setState({ savingPeriodEnd: false });
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    handleSelectProductForEdit = (prod) => {
        const currentId = this.state.selectedProductForEdit ? (this.state.selectedProductForEdit.id ?? this.state.selectedProductForEdit.Id) : null
        const clickedId = prod.id ?? prod.Id
        if (currentId === clickedId) {
            this.setState({ selectedProductForEdit: null, selectedProductForSwitch: null, editPlanPrice: '', editPlanValue: '', editAgentLimit: '', editDiskLimit: '', editAttendanceLimit: '', editAdditionalValueAgent: '', editAttendanceValue: '', editQuantity: '', editDiskOverageValue: '', editBillingMode: 'unit', editCreditAmountMonthly: '', editCreditAlertThreshold: '', editCreditAutoRechargeEnabled: false, editCreditAutoRechargeAmount: '', editCreditAutoRechargeTrigger: '' })
            return
        }
        this.setState({
            selectedProductForEdit: prod,
            selectedProductForSwitch: prod,
            editPlanPrice: prod.planvaluepermonth ?? prod.planValuePerMonth ?? '',
            editPlanValue: prod.planvalue ?? prod.planValue ?? '',
            editAgentLimit: prod.agentlimitquantity ?? prod.agentLimitQuantity ?? '',
            editDiskLimit: prod.disklimitusage ?? prod.diskLimitUsage ?? '',
            editAttendanceLimit: prod.attendancelimitpermonth ?? prod.attendanceLimitPerMonth ?? '',
            editAdditionalValueAgent: prod.additionalvalueagent ?? prod.additionalValueAgent ?? '',
            editAttendanceValue: prod.attendancevalue ?? prod.attendanceValue ?? '',
            editQuantity: prod.quantity ?? prod.Quantity ?? 1,
            editDiskOverageValue: prod.diskoveragevalue ?? prod.diskOverageValue ?? '',
            editBillingMode: prod.billingmode ?? prod.billingMode ?? 'unit',
            editCreditAmountMonthly: prod.creditamountmonthly ?? prod.creditAmountMonthly ?? '',
            editCreditAlertThreshold: prod.creditalertthreshold ?? prod.creditAlertThreshold ?? '',
            editCreditAutoRechargeEnabled: prod.creditautorechargeenabled ?? prod.creditAutoRechargeEnabled ?? false,
            editCreditAutoRechargeAmount: prod.creditautorechargeamount ?? prod.creditAutoRechargeAmount ?? '',
            editCreditAutoRechargeTrigger: prod.creditautorechargetrigger ?? prod.creditAutoRechargeTrigger ?? '',
        });
        const appId = prod.applicationid ?? prod.applicationId ?? 0;
        if (appId) this.loadAllowedBillingModes(appId);
    }

    handleSaveLimits = () => {
        const { selectedProductForEdit, detail } = this.state;
        const intl = this.props.intl;

        if (!selectedProductForEdit) {
            this.showError(intl.formatMessage({ id: "admin.subscription.select.product.first" }));
            return;
        }

        const cppId = selectedProductForEdit.id ?? selectedProductForEdit.Id;

        this.setState({ savingLimits: true });
        adminBillingService.updateProductLimits(cppId, {
            planValuePerMonth: this.state.editPlanPrice !== '' ? parseFloat(this.state.editPlanPrice) : null,
            planValue: this.state.editPlanValue !== '' ? parseFloat(this.state.editPlanValue) : null,
            agentLimitQuantity: this.state.editAgentLimit !== '' ? parseInt(this.state.editAgentLimit) : null,
            diskLimitUsage: this.state.editDiskLimit !== '' ? parseInt(this.state.editDiskLimit) : null,
            attendanceLimitPerMonth: this.state.editAttendanceLimit !== '' ? parseInt(this.state.editAttendanceLimit) : null,
            additionalValueAgent: this.state.editAdditionalValueAgent !== '' ? parseFloat(this.state.editAdditionalValueAgent) : null,
            attendanceValue: this.state.editAttendanceValue !== '' ? parseFloat(this.state.editAttendanceValue) : null,
            quantity: this.state.editQuantity !== '' ? parseInt(this.state.editQuantity) : null,
            diskOverageValue: this.state.editDiskOverageValue !== '' ? parseFloat(this.state.editDiskOverageValue) : null,
            billingMode: this.state.editBillingMode || 'unit',
            creditAmountMonthly: this.state.editCreditAmountMonthly !== '' ? parseFloat(this.state.editCreditAmountMonthly) : null,
            creditAlertThreshold: this.state.editCreditAlertThreshold !== '' ? parseFloat(this.state.editCreditAlertThreshold) : null,
            creditAutoRechargeEnabled: this.state.editCreditAutoRechargeEnabled || false,
            creditAutoRechargeAmount: this.state.editCreditAutoRechargeAmount !== '' ? parseFloat(this.state.editCreditAutoRechargeAmount) : null,
            creditAutoRechargeTrigger: this.state.editCreditAutoRechargeTrigger !== '' ? parseFloat(this.state.editCreditAutoRechargeTrigger) : null,
        })
            .then(result => {
                if (result.data.success) {
                    this.setState({ savingLimits: false });
                    this.showSuccess(intl.formatMessage({ id: "admin.subscription.limits.updated" }));
                    this.loadDetail(detail.hirerid);
                    this.loadContractProducts(detail.hirerid);
                } else {
                    this.setState({ savingLimits: false });
                    this.showError(result.data.errors ? result.data.errors[0] : null);
                }
            })
            .catch(err => {
                this.setState({ savingLimits: false });
                this.showError(err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : null);
                Api.kickoff(err);
            });
    }

    // ========== Hirer Config (Outras Informações) ==========
    loadHirerConfig = () => {
        const { detail } = this.state;
        if (!detail) return;
        adminBillingService.getTrialHirerConfig(detail.hirerid, detail.workspace)
            .then(r => this.setState({ hirerConfig: r.data.success ? r.data.data : null }))
            .catch(() => this.setState({ hirerConfig: null }));
    }

    renderUrlField(label, value) {
        if (!value) return (
            <Grid item xs={12} sm={6}><Typography variant="body2" color="textSecondary">{label}</Typography><Typography variant="body1">-</Typography></Grid>
        );
        const url = value.startsWith('http') ? value : `https://${value}`;
        return (
            <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="textSecondary">{label}</Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Typography variant="body1" style={{ wordBreak: 'break-all' }}>{value}</Typography>
                    <Tooltip title="Abrir em nova aba">
                        <IconButton size="small" onClick={() => window.open(url, '_blank')}><OpenInNewIcon style={{ fontSize: 16, color: '#1976d2' }} /></IconButton>
                    </Tooltip>
                </div>
            </Grid>
        );
    }

    renderHirerConfigTab() {
        const { hirerConfig, detail } = this.state;
        if (!hirerConfig) {
            if (this.state.tabValue === 8 && !this.state._hirerConfigLoaded) {
                this.setState({ _hirerConfigLoaded: true });
                this.loadHirerConfig();
            }
            return (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <HirerCredentialsCard
                            detail={detail}
                            onCopied={(msg) => this.showSuccess(msg)}
                            actions={this.renderRefreshAction(this.refreshHirerConfigTab, this.state.loading)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SectionCard context="info">
                            <Typography variant="body2" color="textSecondary" style={{ padding: 16, textAlign: 'center' }}>
                                Nenhuma configuração encontrada. Clique em outra aba e volte.
                            </Typography>
                        </SectionCard>
                    </Grid>
                </Grid>
            );
        }
        return (
            <Grid container spacing={3}>
                {/* Primeiro bloco: Dados do contrato */}
                <Grid item xs={12}>
                    <HirerCredentialsCard
                        detail={detail}
                        onCopied={(msg) => this.showSuccess(msg)}
                        actions={this.renderRefreshAction(this.refreshHirerConfigTab, this.state.loading)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SectionCard
                        context="settings"
                        title="URLs e Endpoints"
                        actions={(
                            <Button variant="outlined" color="primary" size="small" onClick={this.handleUpdateUrlsToDedicated}>
                                Atualizar URLs da Assinatura
                            </Button>
                        )}
                    >
                        <Grid container spacing={2}>
                            {this.renderUrlField('URL API 2DO', hirerConfig.urlapicube)}
                            {this.renderUrlField('URL API 2SEE', hirerConfig.urlapivertex)}
                            {this.renderUrlField('URL Acesso 2DO', hirerConfig.urlfrontcube)}
                            {this.renderUrlField('URL Acesso 2SEE', hirerConfig.urlfrontvertex)}
                            {this.renderUrlField('URL API Chamados', hirerConfig.urlapicubecalledservice)}
                            {this.renderUrlField('URL Formulário Chamados', hirerConfig.urlfrontcubecalledservice)}
                            {this.renderUrlField('URL API Relatórios', hirerConfig.urlapicubereports)}
                            {this.renderUrlField('URL API 2TALK', hirerConfig.urlapi2talkservice)}
                            {this.renderUrlField('URL Webchat', hirerConfig.urlfront2talkwebchat)}
                        </Grid>
                    </SectionCard>
                </Grid>
                <Grid item xs={12}>
                    <SectionCard context="info" title="Informações Gerais">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Email</Typography><Typography variant="body1">{hirerConfig.email || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Workspace</Typography><Typography variant="body1">{hirerConfig.workspace || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Ambiente</Typography><Typography variant="body1">{hirerConfig.environment || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Versão do Banco</Typography><Typography variant="body1">{hirerConfig.databaseversion || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Última Migration</Typography><Typography variant="body1">{hirerConfig.lastmigrationapplied || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Data Última Migration</Typography><Typography variant="body1">{hirerConfig.lastmigrationdate ? new Date(hirerConfig.lastmigrationdate).toLocaleString('pt-BR') : '-'}</Typography></Grid>
                        </Grid>
                    </SectionCard>
                </Grid>
                {hirerConfig.cloudproviderconfigid && (
                    <Grid item xs={12}>
                        <SectionCard context="provisioning" title="Cloud Provider">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Provider</Typography><Typography variant="body1">{hirerConfig.cloudprovidername || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Configuração</Typography><Typography variant="body1">{hirerConfig.cloudproviderconfigname || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Região</Typography><Typography variant="body1">{hirerConfig.defaultregion || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Profile</Typography><Typography variant="body1">{hirerConfig.profile || '-'}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Code</Typography><Typography variant="body1">{hirerConfig.code || '-'}</Typography></Grid>
                            </Grid>
                        </SectionCard>
                    </Grid>
                )}
            </Grid>
        );
    }

    // ========== Convert to Trial ==========
    handleConvertToTrialConfirm = () => {
        const { detail } = this.state;
        const intl = this.props.intl;
        this.setState({ convertToTrialDialogOpen: false, loading: true });
        adminBillingService.convertToTrial(detail.hirerid, this.state.trialDays)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess('Convertido para Trial com sucesso');
                    setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-trials`), 1500);
                }
                else { this.showError(result.data.errors?.[0]); }
            })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); this.setState({ loading: false }); Api.kickoff(err); });
    }

    // ========== Switch Product Plan ==========
    handleOpenSwitchPlan = (product) => {
        this.setState({
            selectedProductForSwitch: product,
            switchPlanDialogOpen: true,
            switchPlanStep: 0,
            switchSelectedPlanId: null,
            switchSelectedPpId: null,
            switchPlans: [],
            switchPeriodicities: [],
            switchPlansLoading: true,
        });
        // Carregar planos disponíveis pro produto (excluindo trial)
        adminBillingService.getActivePlans(false)
            .then(r => {
                if (r.data.success) {
                    const allPPs = r.data.data || [];
                    const planMap = {};
                    allPPs.forEach(pp => {
                        const key = pp.planid ?? pp.planId;
                        if (!planMap[key]) planMap[key] = { id: key, name: pp.planname ?? pp.planName, isShared: pp.isshared ?? pp.isShared };
                    });
                    this.setState({ switchPlans: Object.values(planMap), switchPlansLoading: false });
                } else { this.setState({ switchPlansLoading: false }); }
            })
            .catch(() => this.setState({ switchPlansLoading: false }));
    }

    handleSwitchPlanSelectPlan = (planId) => {
        this.setState({ switchSelectedPlanId: planId, switchSelectedPpId: null, switchPeriodicities: [], switchPeriodicitiesLoading: true });
        const appId = this.state.selectedProductForSwitch?.applicationid;
        adminProductService.getPlanPeriodicities(planId, appId)
            .then(r => {
                const data = r.data.success ? (r.data.data || []) : [];
                // Excluir o plano atual
                const currentPpId = this.state.selectedProductForSwitch?.planperiodicityid;
                const filtered = data.filter(pp => pp.id !== currentPpId);
                this.setState({ switchPeriodicities: filtered, switchPeriodicitiesLoading: false });
            })
            .catch(() => this.setState({ switchPeriodicitiesLoading: false }));
    }

    handleSwitchPlanConfirm = () => {
        const { detail, selectedProductForSwitch, switchSelectedPpId } = this.state;
        const intl = this.props.intl;
        this.setState({ switchPlanDialogOpen: false, loading: true });
        adminBillingService.switchProductPlan(detail.hirerid, selectedProductForSwitch.applicationid, switchSelectedPpId)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess('Plano do produto alterado com sucesso');
                    this.loadContractProducts(detail.hirerid);
                } else { this.showError(result.data.errors?.[0]); }
            })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); this.setState({ loading: false }); Api.kickoff(err); });
    }

    handleUpdateUrlsToDedicated = () => {
        const { detail } = this.state;
        if (!detail) return;
        this.openProvisioningConfirm(
            'Atualizar URLs da Assinatura',
            'Deseja atualizar todas as URLs de API para o padrão dedicado ({workspace}.aplicacao.ambiente.api.mexx.ai)? As URLs atuais serão sobrescritas.',
            () => {
                this.setState({ loading: true, provisioningConfirmDialog: { open: false } });
                adminBillingService.updateUrlsToDedicated(detail.hirerid)
                    .then(result => {
                        if (result.data.success) {
                            this.showSuccess('URLs atualizadas com sucesso!');
                            this.loadHirerConfig();
                        } else { this.showError(result.data.errors?.[0] || 'Erro ao atualizar URLs'); }
                        this.setState({ loading: false });
                    })
                    .catch(err => { this.showError(err.response?.data?.errors?.[0]); this.setState({ loading: false }); Api.kickoff(err); });
            }
        );
    }

    openProvisioningConfirm = (title, message, action) => this.setState({ provisioningConfirmDialog: { open: true, title, message, action } });

    renderProvisioningTab() {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) {
            return (
                <SectionCard context="provisioning">
                    <Typography variant="body2" color="textSecondary" style={{ padding: 16, textAlign: 'center' }}>
                        Aguardando dados do contrato...
                    </Typography>
                </SectionCard>
            );
        }
        return (
            <>
                <ProvisioningDetailPanel
                    hirerId={detail.hirerid}
                    contractId={detail.contractid}
                    defaultEmail={this.props.userSession?.user?.email || ''}
                    enablePolling={true}
                    onLoadingChange={(loading) => this.setState({ loading })}
                    onNotify={(variant, msg) => this.setState({ openNotification: true, notificationVariant: variant, notificationMessage: msg })}
                />
                {this.renderManualStepsCard()}
            </>
        );
    }

    // ========== Acoes Manuais de Steps ==========
    // Bloco abaixo do ProvisioningDetailPanel pra executar/reverter steps
    // (SeedTrialDemoData, SendWelcomeEmail) em ambientes criados manualmente.
    loadManualStepsWhitelist = () => {
        adminBillingService.getManualStepsWhitelist()
            .then(r => {
                if (r.data && r.data.success) {
                    this.setState({ manualStepsWhitelist: r.data.data || [] });
                } else {
                    this.setState({ manualStepsWhitelist: [] });
                }
            })
            .catch(() => this.setState({ manualStepsWhitelist: [] }));
    }

    handleOpenManualStepDialog = (mode) => {
        // Sempre recarrega no open pra refletir whitelist atual (sem cache stale)
        this.loadManualStepsWhitelist();
        this.setState({
            manualStepDialogOpen: true,
            manualStepMode: mode, // 'execute' ou 'rollback'
            manualStepSelected: '',
            manual2FACode: '',
            manualStepLoading: false,
            manualStepCodeSent: false,
            manualStepCodeSending: false,
            manualStepCodeError: null,
            manualStepCodeRemainingSeconds: 0,
            manualStepResetPassword: false,
        });
        if (this._manualStepTimerId) { clearInterval(this._manualStepTimerId); this._manualStepTimerId = null; }
    }

    handleCloseManualStepDialog = () => {
        this.setState({ manualStepDialogOpen: false });
        if (this._manualStepTimerId) { clearInterval(this._manualStepTimerId); this._manualStepTimerId = null; }
    }

    // Envia codigo 2FA por email (purpose=provisioning_step_rollback)
    handleSendManualStepCode = async () => {
        const { detail } = this.state;
        const email = this.props.userSession?.user?.email || '';
        this.setState({ manualStepCodeSending: true, manualStepCodeError: null });
        try {
            const result = await adminBillingService.sendStepRollbackTwoFactorCode(detail.hirerid, email);
            if (result.data && result.data.success) {
                const expiresAt = result.data.data?.expiresat ?? result.data.data?.expiresAt;
                const exp = expiresAt ? new Date(expiresAt).getTime() : (Date.now() + 5 * 60 * 1000);
                const remaining = Math.max(0, Math.floor((exp - Date.now()) / 1000));
                this.setState({ manualStepCodeSent: true, manualStepCodeSending: false, manualStepCodeRemainingSeconds: remaining });
                if (this._manualStepTimerId) clearInterval(this._manualStepTimerId);
                this._manualStepTimerId = setInterval(() => {
                    this.setState(prev => {
                        const left = Math.max(0, prev.manualStepCodeRemainingSeconds - 1);
                        if (left === 0 && this._manualStepTimerId) { clearInterval(this._manualStepTimerId); this._manualStepTimerId = null; }
                        return { manualStepCodeRemainingSeconds: left };
                    });
                }, 1000);
            } else {
                this.setState({
                    manualStepCodeSending: false,
                    manualStepCodeError: result.data?.errors?.[0] || 'Falha ao enviar codigo'
                });
            }
        } catch (err) {
            this.setState({
                manualStepCodeSending: false,
                manualStepCodeError: err?.response?.data?.errors?.[0] || 'Falha ao enviar codigo'
            });
        }
    }

    // Submit do execute/rollback. Backend publica evento via outbox e retorna queueId.
    // Frontend aguarda processamento via polling de getProvisioningDetail(queueId).
    handleConfirmManualStep = async () => {
        const { detail, manualStepMode, manualStepSelected, manual2FACode } = this.state;
        if (!manualStepSelected) return;
        this.setState({ manualStepLoading: true, manualStepProgress: 'submitting' });
        try {
            let result;
            if (manualStepMode === 'rollback') {
                if (!manual2FACode || manual2FACode.length < 6) {
                    this.setState({ manualStepLoading: false, manualStepProgress: null, openNotification: true, notificationVariant: 'error', notificationMessage: 'Informe o codigo 2FA (6 digitos)' });
                    return;
                }
                result = await adminBillingService.rollbackManualStep(detail.hirerid, manualStepSelected, manual2FACode);
            } else {
                result = await adminBillingService.executeManualStep(
                    detail.hirerid,
                    manualStepSelected,
                    { resetPassword: !!this.state.manualStepResetPassword },
                );
            }
            const success = result?.data?.success;
            const payload = result?.data?.data;
            if (!success) {
                const msg = result?.data?.errors?.[0] || 'Falha ao publicar evento';
                this.setState({
                    manualStepLoading: false,
                    manualStepProgress: null,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: msg,
                });
                return;
            }
            // Recebeu queueId; inicia polling pra saber status real do step
            const queueId = payload?.provisioningqueueid ?? payload?.provisioningQueueId;
            if (!queueId) {
                // Caminho defensivo: evento foi publicado mas backend nao devolveu queueId
                this.setState({
                    manualStepLoading: false,
                    manualStepDialogOpen: false,
                    manualStepProgress: null,
                    openNotification: true,
                    notificationVariant: 'success',
                    notificationMessage: 'Evento publicado. Verifique o painel de provisionamento.',
                });
                return;
            }
            this.startManualStepPolling(queueId, manualStepMode, manualStepSelected);
        } catch (err) {
            this.setState({
                manualStepLoading: false,
                manualStepProgress: null,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: err?.response?.data?.errors?.[0] || 'Erro inesperado',
            });
        }
    }

    // Polling do status da queue ate ver 'completed' ou 'failed' do step alvo.
    // Lê tb_provisioning_queue_history (via GET /admin/provisioning/{id}) e
    // procura entry mais recente do step. ~30s timeout.
    startManualStepPolling = (queueId, mode, stepName) => {
        let attempts = 0;
        const maxAttempts = 30; // 30 × 2s = 60s
        const poll = async () => {
            attempts++;
            try {
                const res = await adminBillingService.getProvisioningDetail(queueId);
                if (res?.data?.success) {
                    const data = res.data.data;
                    const steps = data?.steps || [];
                    // Pega o step alvo pelo nome
                    const targetStep = steps.find(s => (s.stepname ?? s.stepName) === stepName);
                    const status = (targetStep?.status || '').toLowerCase();
                    if (status === 'completed' || status === 'rolled_back') {
                        const verb = mode === 'rollback' ? 'revertido' : 'executado';
                        this.setState({
                            manualStepLoading: false,
                            manualStepDialogOpen: false,
                            manualStepProgress: null,
                            openNotification: true,
                            notificationVariant: 'success',
                            notificationMessage: `Passo ${stepName} ${verb} com sucesso`,
                        });
                        return;
                    }
                    if (status === 'failed' || status === 'rollback_failed' || status === 'error') {
                        this.setState({
                            manualStepLoading: false,
                            manualStepProgress: null,
                            openNotification: true,
                            notificationVariant: 'error',
                            notificationMessage: targetStep?.errormessage || targetStep?.errorMessage || `Falha no passo ${stepName}`,
                        });
                        return;
                    }
                    // Mantem spinner com mensagem de progresso
                    this.setState({ manualStepProgress: 'processing' });
                }
            } catch (err) {
                // Pontual — continua tentando
            }
            if (attempts >= maxAttempts) {
                this.setState({
                    manualStepLoading: false,
                    manualStepProgress: null,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: 'Tempo limite excedido. Verifique no painel de provisionamento.',
                });
                return;
            }
            setTimeout(poll, 2000);
        };
        setTimeout(poll, 1500);
    }

    formatRemaining(seconds) {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${String(s).padStart(2, '0')}`;
    }

    renderManualStepsCard() {
        const { manualStepsWhitelist = [] } = this.state;
        return (
            <SectionCard context="provisioning" style={{ marginTop: 16 }}>
                <div style={{ padding: 16 }}>
                    <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 8 }}>Acoes Manuais de Passos</Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                        Execute ou reverta passos individuais do pipeline em ambientes criados fora do fluxo padrao.
                        Apenas passos idempotentes/cosmeticos estao disponiveis.
                    </Typography>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                        <Button variant="contained"
                            onClick={() => this.handleOpenManualStepDialog('execute')}
                            style={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#1976d2', color: '#fff' }}>
                            Executar Passo
                        </Button>
                        <Button variant="contained"
                            onClick={() => this.handleOpenManualStepDialog('rollback')}
                            style={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#e53935', color: '#fff' }}>
                            Reverter Passo
                        </Button>
                    </div>
                    {manualStepsWhitelist.length > 0 && (
                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 12 }}>
                            Passos disponiveis: {manualStepsWhitelist.map(s => s.displayName || s.name).join(', ')}
                        </Typography>
                    )}
                </div>
                {this.renderManualStepDialog()}
            </SectionCard>
        );
    }

    renderManualStepDialog() {
        const {
            manualStepDialogOpen, manualStepMode, manualStepSelected, manualStepsWhitelist = [],
            manual2FACode, manualStepLoading, manualStepProgress,
            manualStepCodeSent, manualStepCodeSending, manualStepCodeError, manualStepCodeRemainingSeconds
        } = this.state;
        const isRollback = manualStepMode === 'rollback';
        const selectedStep = manualStepsWhitelist.find(s => s.name === manualStepSelected);
        const email = this.props.userSession?.user?.email || '';
        const canConfirm = !!manualStepSelected
            && !manualStepLoading
            && (!isRollback || (manualStepCodeSent && manual2FACode && manual2FACode.length >= 6));
        const progressLabel = manualStepProgress === 'submitting'
            ? 'Publicando evento...'
            : (manualStepProgress === 'processing' ? 'Aguardando processamento...' : null);

        return (
            <ConfirmActionDialog
                open={!!manualStepDialogOpen}
                onClose={this.handleCloseManualStepDialog}
                onConfirm={this.handleConfirmManualStep}
                title={isRollback ? 'Reverter Passo Manual' : 'Executar Passo Manual'}
                message={isRollback
                    ? 'Esta acao removera dados do ambiente. Acao irreversivel — confirmacao 2FA obrigatoria.'
                    : 'Selecione o passo a executar neste ambiente.'}
                confirmLabel={progressLabel || (isRollback ? 'Reverter' : 'Executar')}
                confirmColor={isRollback ? '#e53935' : '#1976d2'}
                confirmDisabled={!canConfirm}
                loading={manualStepLoading}
            >
                <TextField
                    select
                    fullWidth
                    label="Passo"
                    value={manualStepSelected}
                    onChange={e => this.setState({ manualStepSelected: e.target.value, manual2FACode: '', manualStepCodeSent: false })}
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                    style={{ marginBottom: 12 }}
                >
                    <option value="">Selecione...</option>
                    {manualStepsWhitelist.map(s => (
                        <option key={s.name} value={s.name}>{s.displayName || s.name}</option>
                    ))}
                </TextField>
                {selectedStep && (
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
                        {selectedStep.description}
                    </Typography>
                )}

                {/* Checkbox "Resetar senha" — apenas Execute do SendWelcomeEmail */}
                {!isRollback && manualStepSelected === 'SendWelcomeEmail' && (
                    <div style={{ marginTop: 8, marginBottom: 12, padding: 10, backgroundColor: '#fff8e1', border: '1px solid #ffe082', borderRadius: 6 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                            <input
                                type="checkbox"
                                checked={!!this.state.manualStepResetPassword}
                                onChange={e => this.setState({ manualStepResetPassword: e.target.checked })}
                            />
                            <span style={{ fontSize: 14 }}>
                                Resetar senha do admin e incluir a nova senha no email
                            </span>
                        </label>
                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 4, marginLeft: 24 }}>
                            Marcado: gera senha nova e atualiza no banco do tenant. Desmarcado: envia o email sem senha (admin usa atual).
                        </Typography>
                    </div>
                )}

                {isRollback && manualStepSelected && (
                    <div style={{ marginTop: 12, padding: 12, backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: 6 }}>
                        <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8 }}>
                            Codigo 2FA por email
                        </Typography>
                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 12 }}>
                            Sera enviado pra <strong>{email}</strong>
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                            <Button
                                variant="outlined"
                                onClick={this.handleSendManualStepCode}
                                disabled={manualStepCodeSending || (manualStepCodeRemainingSeconds > 0 && manualStepCodeSent)}
                                style={{ textTransform: 'none' }}
                            >
                                {manualStepCodeSending
                                    ? 'Enviando...'
                                    : (manualStepCodeSent ? 'Reenviar codigo' : 'Enviar codigo')}
                            </Button>
                            {manualStepCodeSent && manualStepCodeRemainingSeconds > 0 && (
                                <Typography variant="caption" color="textSecondary">
                                    Expira em {this.formatRemaining(manualStepCodeRemainingSeconds)}
                                </Typography>
                            )}
                        </div>
                        {manualStepCodeError && (
                            <Typography variant="caption" style={{ color: '#c62828', display: 'block', marginBottom: 8 }}>
                                {manualStepCodeError}
                            </Typography>
                        )}
                        <TextField
                            fullWidth
                            label="Codigo recebido"
                            value={manual2FACode}
                            onChange={e => this.setState({ manual2FACode: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                            placeholder="6 digitos"
                            disabled={!manualStepCodeSent}
                            inputProps={{ maxLength: 6, style: { letterSpacing: 4, fontFamily: 'monospace' } }}
                        />
                    </div>
                )}
            </ConfirmActionDialog>
        );
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    renderSummaryTab() {
        const { detail, editStatusId, editPeriodEnd, savingStatus, savingPeriodEnd } = this.state;
        const intl = this.props.intl;
        if (!detail) return null;

        // Quando deprovisionamento está agendado/em execução, todas as outras ações ficam disabled.
        const ds = this.state.deprovisioningStatus;
        const isDeprovisioningInProgress = ds?.provisioningstatus === 'deprovisioning_scheduled'
                                            || ds?.provisioningstatus === 'deprovisioning';

        return (
            <div style={{ marginTop: 16 }}>
            <SectionCard
                context="info"
                title={detail.name}
                subtitle={intl.formatMessage({ id: "admin.subscription.detail" })}
                actions={this.renderRefreshAction(this.refreshSummaryTab, this.state.loading)}
            >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">Workspace</Typography>
                            <Typography variant="body1">{detail.workspace || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "email" })}</Typography>
                            <Typography variant="body1">{detail.email || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.subscription.contract.id" })}</Typography>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{detail.contractid ?? '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.subscription.contract.status" })}</Typography>
                            <ContractStatusBadge statusId={detail.contractstatusid} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">Status de provisionamento</Typography>
                            {(this.state.deprovisioningStatus?.provisioningstatus || detail.provisioningstatus)
                                ? <ProvisioningStatusBadge status={this.state.deprovisioningStatus?.provisioningstatus || detail.provisioningstatus} />
                                : <Typography variant="body1" style={{ color: '#9e9e9e' }}>—</Typography>}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.subscription.sub.status" })}</Typography>
                            {detail.paymentgatewaytype === 'manual'
                                ? <Chip label="Manual" size="small" style={{ backgroundColor: '#fff3e0', fontWeight: 500, fontSize: 11 }} />
                                : <SubscriptionStatusBadge status={detail.subscriptionstatus} />
                            }
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">Gateway Customer ID</Typography>
                            <Typography variant="body1" style={{ fontSize: 12 }}>{detail.gatewaycustomerid || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">Gateway Subscription ID</Typography>
                            <Typography variant="body1" style={{ fontSize: 12 }}>{detail.gatewaysubscriptionid || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.hirer.company_size" })}</Typography>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Typography variant="body1">{detail.companysizename || '—'}</Typography>
                                <IconButton size="small" onClick={this.openCompanySizeDialog} title="Editar"><EditIcon fontSize="small" /></IconButton>
                            </div>
                        </Grid>

                        {/* Editable: Contract Status */}
                        <Grid item xs={12}>
                            <Divider style={{ margin: '12px 0' }} />
                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8, color: '#424242' }}>
                                {intl.formatMessage({ id: "admin.subscription.edit.section" })}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <TextField select label={intl.formatMessage({ id: "admin.subscription.contract.status" })} value={editStatusId} onChange={(e) => this.setState({ editStatusId: e.target.value })} fullWidth variant="outlined" size="small" SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
                                {CONTRACT_STATUSES.map(s => (<option key={s.id} value={s.id}>[{s.id}] {s.name}</option>))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={1} style={{ display: 'flex', alignItems: 'center' }}>
                            <Button variant="contained" color="primary" size="small" onClick={this.handleSaveStatus} disabled={savingStatus || editStatusId === detail.contractstatusid || isDeprovisioningInProgress} startIcon={<SaveIcon />} style={isDeprovisioningInProgress ? { backgroundColor: '#bdbdbd', color: '#fff', cursor: 'not-allowed', boxShadow: 'none' } : undefined}>
                                {intl.formatMessage({ id: "save" })}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.period.end" })} type="date" value={editPeriodEnd} onChange={(e) => this.setState({ editPeriodEnd: e.target.value })} fullWidth variant="outlined" size="small" InputLabelProps={{ shrink: true }} disabled={isDeprovisioningInProgress} />
                        </Grid>
                        <Grid item xs={12} sm={1} style={{ display: 'flex', alignItems: 'center' }}>
                            <Button variant="contained" color="primary" size="small" onClick={this.handleSavePeriodEnd} disabled={savingPeriodEnd || !editPeriodEnd || isDeprovisioningInProgress} startIcon={<SaveIcon />} style={isDeprovisioningInProgress ? { backgroundColor: '#bdbdbd', color: '#fff', cursor: 'not-allowed', boxShadow: 'none' } : undefined}>
                                {intl.formatMessage({ id: "save" })}
                            </Button>
                        </Grid>

                        {/* Payment Gateway Selector */}
                        <Grid item xs={12}>
                            <Divider style={{ margin: '8px 0' }} />
                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8, color: '#424242' }}>
                                {intl.formatMessage({ id: "admin.gateway.title" })}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">
                                {intl.formatMessage({ id: "admin.gateway.current" })}
                            </Typography>
                            <Typography variant="body1">
                                {detail.paymentgatewayname || intl.formatMessage({ id: "admin.gateway.none" })}
                                {detail.paymentgatewaytype ? ` (${detail.paymentgatewaytype})` : ''}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <TextField
                                select
                                label={intl.formatMessage({ id: "admin.gateway.select" })}
                                value={this.state.editGatewayId}
                                onChange={(e) => this.setState({ editGatewayId: e.target.value })}
                                fullWidth
                                size="small"
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                            >
                                <option value=""></option>
                                {this.state.paymentGateways.map(gw => (
                                    <option key={gw.id} value={gw.id}>
                                        {gw.name} ({gw.gatewaytype ?? gw.gatewayType}){(gw.isdefault ?? gw.isDefault) ? ' *' : ''}
                                    </option>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={3} style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                onClick={this.handleSaveGateway}
                                disabled={this.state.savingGateway || isDeprovisioningInProgress}
                                style={isDeprovisioningInProgress ? { backgroundColor: '#bdbdbd', color: '#fff', cursor: 'not-allowed', boxShadow: 'none' } : undefined}
                            >
                                {intl.formatMessage({ id: "admin.gateway.save" })}
                            </Button>
                        </Grid>

                        {!detail.gatewaysubscriptionid && (
                            <Grid item xs={12}>
                                <div style={{
                                    padding: '12px 16px',
                                    backgroundColor: '#fff3e0',
                                    border: '1px solid #ffb74d',
                                    borderRadius: 4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    <Typography variant="body2" style={{ color: '#e65100' }}>
                                        {intl.formatMessage({ id: "admin.subscription.no.gateway" })}
                                    </Typography>
                                    {(() => {
                                        const isDisabled = this.state.creatingSubscription || detail.paymentgatewaytype === 'manual' || isDeprovisioningInProgress;
                                        return (
                                            <Button
                                                variant="contained"
                                                size="small"
                                                startIcon={<PaymentIcon />}
                                                style={{
                                                    backgroundColor: isDisabled ? '#bdbdbd' : '#1976d2',
                                                    color: '#fff',
                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                    boxShadow: isDisabled ? 'none' : undefined,
                                                }}
                                                onClick={this.handleCreateSubscription}
                                                disabled={isDisabled}
                                            >
                                                {intl.formatMessage({ id: "admin.subscription.create.gateway" })}
                                            </Button>
                                        );
                                    })()}
                                </div>
                            </Grid>
                        )}
                        {detail.trialenddate && (
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.end.date" })}</Typography>
                                <Typography variant="body1">{new Date(detail.trialenddate).toLocaleDateString('pt-BR')}</Typography>
                            </Grid>
                        )}
                        {detail.cancelatperiodend && (
                            <Grid item xs={12}>
                                <Typography variant="body2" style={{ color: '#f44336', fontWeight: 500 }}>
                                    Cancelamento agendado para o fim do periodo
                                    {detail.canceledat ? ` (solicitado em ${new Date(detail.canceledat).toLocaleDateString('pt-BR')})` : ''}
                                </Typography>
                            </Grid>
                        )}

                        {/* Banner de erro quando provisionamento/desprovisionamento falhou */}
                        <Grid item xs={12}>
                            <ProvisioningErrorBanner
                                status={this.state.deprovisioningStatus?.provisioningstatus}
                                errorMessage={this.state.deprovisioningStatus?.errormessage}
                                failedStep={this.state.deprovisioningStatus?.failedstep}
                            />
                        </Grid>

                        {/* Contracted Products Section */}
                        <Grid item xs={12}>
                            <Divider style={{ margin: '12px 0' }} />
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#424242' }}>
                                    {intl.formatMessage({ id: "admin.contract.products.title" })}
                                </Typography>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        disabled={!this.state.selectedProductForSwitch}
                                        onClick={() => this.handleOpenSwitchPlan(this.state.selectedProductForSwitch)}
                                    >
                                        Converter Plano
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={() => this.setState({ addProductDialogOpen: true })}
                                    >
                                        {intl.formatMessage({ id: "admin.subscription.add.product" })}
                                    </Button>
                                </div>
                            </div>

                            {this.state.contractProducts.length === 0 ? (
                                <Typography variant="body2" color="textSecondary" style={{ padding: '16px 0' }}>
                                    {intl.formatMessage({ id: "admin.contract.products.empty" })}
                                </Typography>
                            ) : (
                                <TableContainer component={Paper} variant="outlined" style={{ marginBottom: 8 }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 700, fontSize: '0.8rem', color: '#424242', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '2px solid #9e9e9e' }}>
                                                <TableCell>{intl.formatMessage({ id: "admin.contract.products.product" })}</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.contract.products.plan" })}</TableCell>
                                                <TableCell align="right">Valor Contratado</TableCell>
                                                <TableCell align="right">{intl.formatMessage({ id: "admin.contract.products.qty" })}</TableCell>
                                                <TableCell align="right">Valor Total</TableCell>
                                                <TableCell>{intl.formatMessage({ id: "admin.pp.billing.mode" })}</TableCell>
                                                <TableCell align="center">{intl.formatMessage({ id: "admin.contract.products.limits" })}</TableCell>
                                                <TableCell align="center">{intl.formatMessage({ id: "actions" })}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.contractProducts.map((prod, idx) => {
                                                const isSelectedProd = this.state.selectedProductForEdit && (this.state.selectedProductForEdit.id ?? this.state.selectedProductForEdit.Id) === (prod.id ?? prod.Id)
                                                // Valores derivados (mesma logica do mexx2do):
                                                // contractedValue = plan_value (preco unitario no periodo)
                                                // monthly = plan_value_per_month (mensal canonico)
                                                // lineTotal = plan_value × quantity
                                                const monthly = Number(prod.planvaluepermonth ?? prod.planValuePerMonth ?? 0)
                                                const qty = Number(prod.quantity ?? prod.Quantity ?? 1)
                                                const contractedValue = Number(prod.planvalue ?? prod.planValue ?? monthly)
                                                const lineTotal = contractedValue * qty
                                                const monthlyEquiv = monthly * qty
                                                const isCourtesy = contractedValue === 0
                                                return (
                                                <TableRow key={idx} hover
                                                    style={{ cursor: 'pointer', backgroundColor: isSelectedProd ? '#e8f5e9' : (idx % 2 === 0 ? '#fff' : '#fafafa') }}
                                                    onClick={() => this.handleSelectProductForEdit(prod)}
                                                >
                                                    <TableCell><strong>{prod.applicationname}</strong></TableCell>
                                                    <TableCell>{prod.planname}{prod.periodicityname ? ` (${prod.periodicityname})` : ''}</TableCell>
                                                    <TableCell align="right">
                                                        {isCourtesy ? (
                                                            <Chip label="Cortesia" size="small" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontWeight: 600 }} />
                                                        ) : (
                                                            `R$ ${contractedValue.toFixed(2)}`
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="right">{qty}</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: 600 }}>
                                                        {isCourtesy ? (
                                                            <span style={{ color: '#2e7d32' }}>—</span>
                                                        ) : (
                                                            <>
                                                                <div>R$ {lineTotal.toFixed(2)}</div>
                                                                {monthlyEquiv !== lineTotal && (
                                                                    <Typography variant="caption" style={{ color: '#9e9e9e' }}>
                                                                        equiv. R$ {monthlyEquiv.toFixed(2)}/mês
                                                                    </Typography>
                                                                )}
                                                            </>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Chip label={(prod.billingmode ?? 'unit') === 'credit' ? 'Crédito' : 'Unidade'} size="small"
                                                            style={{ backgroundColor: (prod.billingmode ?? 'unit') === 'credit' ? '#e3f2fd' : '#f5f5f5', color: (prod.billingmode ?? 'unit') === 'credit' ? '#1565c0' : '#616161' }} />
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontSize: 12 }}>
                                                        {prod.agentlimitquantity != null ? `${prod.agentlimitquantity} ag` : ''}
                                                        {prod.disklimitusage != null ? ` | ${prod.disklimitusage} MB` : ''}
                                                        {prod.attendancelimitpermonth != null ? ` | ${prod.attendancelimitpermonth} at/m` : ''}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Tooltip title={intl.formatMessage({ id: "admin.contract.products.remove" })}>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => this.setState({ removeProductDialogOpen: true, removeProductId: prod.applicationid })}
                                                                style={{ color: '#e53935' }}
                                                            >
                                                                <BlockIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}

                            {/* Detalhe do calculo + total geral. Mesmo padrao do modal "Assinar Agora"
                                (mexx2do-ui passo 5 do Resumo) — transparencia de como o valor final eh
                                composto, somando subtotal por produto. Itens com plan_value=0 (cortesia)
                                aparecem como "Cortesia" sem somar no total. */}
                            {this.state.contractProducts.length > 0 && (() => {
                                const products = this.state.contractProducts || [];
                                // Formatter BR padrao do projeto. Mesmo helper inline usado em outros
                                // blocos (ex: linha 2284 e formatCurrency da linha 2800).
                                const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(v) || 0);
                                let totalPeriod = 0;
                                let totalMonthly = 0;
                                const uniquePeriodicities = new Set();
                                products.forEach(p => {
                                    const monthly = Number(p.planvaluepermonth ?? p.planValuePerMonth ?? 0);
                                    const qty = Number(p.quantity ?? p.Quantity ?? 1);
                                    const contractedValue = Number(p.planvalue ?? p.planValue ?? monthly);
                                    totalPeriod += contractedValue * qty;
                                    totalMonthly += monthly * qty;
                                    const pn = (p.periodicityname ?? p.periodicityName ?? '').toLowerCase();
                                    if (pn) uniquePeriodicities.add(pn);
                                });
                                const totalLabel = uniquePeriodicities.size === 1
                                    ? `Total ${[...uniquePeriodicities][0]}`
                                    : 'Total no período';
                                return (
                                    <div style={{
                                        marginTop: 16, padding: '16px 20px',
                                        backgroundColor: '#f5f7fa', borderRadius: 8,
                                        border: '1px solid #e0e0e0'
                                    }}>
                                        <Typography variant="caption" style={{
                                            fontWeight: 700, color: '#9e9e9e',
                                            textTransform: 'uppercase', letterSpacing: 1,
                                            marginBottom: 10, display: 'block'
                                        }}>
                                            Detalhe do cálculo
                                        </Typography>
                                        {products.map(prod => {
                                            const monthly = Number(prod.planvaluepermonth ?? prod.planValuePerMonth ?? 0);
                                            const qty = Number(prod.quantity ?? prod.Quantity ?? 1);
                                            const contractedValue = Number(prod.planvalue ?? prod.planValue ?? monthly);
                                            const lineTotal = contractedValue * qty;
                                            const isCourtesy = contractedValue === 0;
                                            const periodicityName = prod.periodicityname ?? prod.periodicityName ?? '-';
                                            return (
                                                <div key={prod.id ?? prod.Id} style={{
                                                    display: 'flex', justifyContent: 'space-between',
                                                    alignItems: 'center', padding: '4px 0',
                                                    fontSize: 14, color: '#616161'
                                                }}>
                                                    <span>
                                                        <strong>{prod.applicationname}</strong> ({periodicityName}):
                                                        {isCourtesy
                                                            ? <span style={{ marginLeft: 6, color: '#2e7d32', fontWeight: 600 }}>Cortesia ({qty} {qty === 1 ? 'licença' : 'licenças'})</span>
                                                            : ` ${qty} × ${fmt(contractedValue)}`}
                                                    </span>
                                                    <span style={{ fontWeight: 600, color: isCourtesy ? '#2e7d32' : '#424242' }}>
                                                        {isCourtesy ? '—' : fmt(lineTotal)}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                        <Divider style={{ margin: '12px 0' }} />
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="h6" style={{ fontWeight: 600, color: '#424242' }}>
                                                {totalLabel}:
                                            </Typography>
                                            <Typography variant="h5" style={{ fontWeight: 800, color: '#277afe' }}>
                                                {fmt(totalPeriod)}
                                            </Typography>
                                        </div>
                                        {totalMonthly !== totalPeriod && (
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}>
                                                <Typography variant="caption" color="textSecondary">
                                                    Equivalente mensal (MRR): {fmt(totalMonthly)}/mês
                                                </Typography>
                                            </div>
                                        )}
                                    </div>
                                );
                            })()}
                        </Grid>

                        {/* Editable: Product Limits */}
                        <Grid item xs={12}>
                            <Divider style={{ margin: '12px 0' }} />
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#424242' }}>
                                    {intl.formatMessage({ id: "admin.subscription.edit.limits" })}
                                </Typography>
                                {this.state.selectedProductForEdit && (
                                    <div style={{
                                        marginLeft: 12, padding: '4px 12px',
                                        backgroundColor: '#f1f8e9', border: '1px solid #8BC34A',
                                        borderRadius: 16, display: 'inline-flex', alignItems: 'center'
                                    }}>
                                        <Typography variant="body2" style={{ fontWeight: 600, color: '#558B2F' }}>
                                            {this.state.selectedProductForEdit.applicationname} — {this.state.selectedProductForEdit.planname}{this.state.selectedProductForEdit.periodicityname ? ` / ${this.state.selectedProductForEdit.periodicityname}` : ''}
                                        </Typography>
                                    </div>
                                )}
                            </div>
                            {!this.state.selectedProductForEdit && (
                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                                    {intl.formatMessage({ id: "admin.subscription.select.product.first" })}
                                </Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.price" })} type="number" value={this.state.editPlanPrice} onChange={(e) => this.setState({ editPlanPrice: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.plan.value" })} type="number" value={this.state.editPlanValue} onChange={(e) => this.setState({ editPlanValue: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.agents" })} type="number" value={this.state.editAgentLimit} onChange={(e) => this.setState({ editAgentLimit: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.disk" })} type="number" value={this.state.editDiskLimit} onChange={(e) => this.setState({ editDiskLimit: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.attendances" })} type="number" value={this.state.editAttendanceLimit} onChange={(e) => this.setState({ editAttendanceLimit: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.additional.agent" })} type="number" value={this.state.editAdditionalValueAgent} onChange={(e) => this.setState({ editAdditionalValueAgent: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.attendance.value" })} type="number" value={this.state.editAttendanceValue} onChange={(e) => this.setState({ editAttendanceValue: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.00001', min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.subscription.quantity" })} type="number" value={this.state.editQuantity} onChange={(e) => this.setState({ editQuantity: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ min: '1' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField label={intl.formatMessage({ id: "admin.pp.disk.overage.value" })} type="number" value={this.state.editDiskOverageValue} onChange={(e) => this.setState({ editDiskOverageValue: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} disabled={!this.state.selectedProductForEdit} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            {(() => {
                                const modes = (this.state.billingModes || []).filter(bm => (this.state.selectedProductAllowedModes || []).includes(bm.id ?? bm.Id));
                                const hasMultiple = modes.length > 1;
                                return hasMultiple ? (
                                    <TextField select label={intl.formatMessage({ id: "admin.pp.billing.mode" })} value={this.state.editBillingMode} onChange={(e) => this.setState({ editBillingMode: e.target.value })} fullWidth variant="outlined" size="small" SelectProps={{ native: true }} InputLabelProps={{ shrink: true }} disabled={!this.state.selectedProductForEdit}>
                                        {modes.map(bm => (
                                            <option key={bm.id ?? bm.Id} value={bm.code ?? bm.Code}>{bm.name ?? bm.Name ?? '-'}</option>
                                        ))}
                                    </TextField>
                                ) : (
                                    <TextField label={intl.formatMessage({ id: "admin.pp.billing.mode" })} value={modes.length === 1 ? (modes[0].name ?? modes[0].Name ?? '-') : (this.state.editBillingMode === 'credit' ? 'Por Crédito' : 'Por Unidade')} fullWidth variant="outlined" size="small" disabled InputProps={{ style: { backgroundColor: '#ebebeb', color: '#777' } }} />
                                );
                            })()}
                        </Grid>
                        {this.state.editBillingMode === 'credit' && this.state.selectedProductForEdit && (
                            <>
                                <Grid item xs={12}><Divider style={{ margin: '4px 0' }} /><Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase' }}>{intl.formatMessage({ id: "admin.pp.credit.section" })}</Typography></Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField label={intl.formatMessage({ id: "admin.pp.credit.monthly" })} type="number" value={this.state.editCreditAmountMonthly} onChange={(e) => this.setState({ editCreditAmountMonthly: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField label={intl.formatMessage({ id: "admin.pp.credit.alert" })} type="number" value={this.state.editCreditAlertThreshold} onChange={(e) => this.setState({ editCreditAlertThreshold: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField select label={intl.formatMessage({ id: "admin.pp.credit.auto.recharge" })} value={this.state.editCreditAutoRechargeEnabled ? 'true' : 'false'} onChange={(e) => this.setState({ editCreditAutoRechargeEnabled: e.target.value === 'true' })} fullWidth variant="outlined" size="small" SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
                                        <option value="false">Não</option>
                                        <option value="true">Sim</option>
                                    </TextField>
                                </Grid>
                                {this.state.editCreditAutoRechargeEnabled && (
                                    <>
                                        <Grid item xs={12} sm={3}>
                                            <TextField label={intl.formatMessage({ id: "admin.pp.credit.recharge.amount" })} type="number" value={this.state.editCreditAutoRechargeAmount} onChange={(e) => this.setState({ editCreditAutoRechargeAmount: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField label={intl.formatMessage({ id: "admin.pp.credit.recharge.trigger" })} type="number" value={this.state.editCreditAutoRechargeTrigger} onChange={(e) => this.setState({ editCreditAutoRechargeTrigger: e.target.value })} fullWidth variant="outlined" size="small" inputProps={{ step: '0.01', min: '0' }} />
                                        </Grid>
                                    </>
                                )}
                            </>
                        )}
                        {/* Valor Total Calculado */}
                        {this.state.selectedProductForEdit && (
                            <Grid item xs={12}>
                                <div style={{
                                    padding: '12px 20px', backgroundColor: '#f1f8e9',
                                    border: '1px solid #8BC34A', borderRadius: 8,
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                                }}>
                                    <Typography variant="subtitle2" style={{ color: '#558B2F', fontWeight: 600 }}>
                                        {intl.formatMessage({ id: "admin.subscription.total.value" })}
                                    </Typography>
                                    <Typography variant="h5" style={{ fontWeight: 700, color: '#2e7d32' }}>
                                        {(() => {
                                            const qty = parseInt(this.state.editQuantity) || 1
                                            const price = parseFloat(this.state.editPlanPrice) || 0
                                            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(qty * price)
                                        })()}
                                    </Typography>
                                </div>
                            </Grid>
                        )}
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={this.handleSaveLimits}
                                disabled={this.state.savingLimits || !this.state.selectedProductForEdit}
                                startIcon={<SaveIcon />}
                            >
                                {intl.formatMessage({ id: "save" })}
                            </Button>
                        </Grid>

                        <Grid item xs={12}>
                            <Divider style={{ margin: '12px 0' }} />
                            <Button variant="contained" style={(detail.contractstatusid === 5 || isDeprovisioningInProgress) ? { backgroundColor: '#bdbdbd', color: '#fff', marginRight: 8, cursor: 'not-allowed', boxShadow: 'none' } : { backgroundColor: '#2196f3', color: '#fff', marginRight: 8 }}
                                onClick={() => this.setState({ convertToTrialDialogOpen: true })}
                                disabled={detail.contractstatusid === 5 || isDeprovisioningInProgress}>
                                Converter para Trial
                            </Button>
                            {detail.contractstatusid !== 6 ? (() => {
                                const blockDisabled = detail.contractstatusid === 4 || isDeprovisioningInProgress;
                                return (
                                    <Button variant="contained" style={{
                                        backgroundColor: blockDisabled ? '#bdbdbd' : '#ff9800',
                                        color: '#fff',
                                        marginRight: 8,
                                        cursor: blockDisabled ? 'not-allowed' : 'pointer',
                                        boxShadow: blockDisabled ? 'none' : undefined,
                                    }} onClick={() => this.setState({ blockDialogOpen: true })} disabled={blockDisabled}>
                                        {intl.formatMessage({ id: "admin.subscription.block" })}
                                    </Button>
                                );
                            })() : (
                                <Button variant="contained" style={isDeprovisioningInProgress ? { backgroundColor: '#bdbdbd', color: '#fff', marginRight: 8, cursor: 'not-allowed', boxShadow: 'none' } : { backgroundColor: '#4caf50', color: '#fff', marginRight: 8 }} onClick={this.handleUnblock} disabled={isDeprovisioningInProgress}>
                                    {intl.formatMessage({ id: "admin.subscription.unblock" })}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
            </SectionCard>
            </div>
        );
    }

    renderDangerZone() {
        const detail = this.state.detail || {};
        if (!detail.hirerid) return null;
        const ds = this.state.deprovisioningStatus;
        const isDeprovisioningInProgress = ds?.provisioningstatus === 'deprovisioning_scheduled'
                                            || ds?.provisioningstatus === 'deprovisioning';
        return (
            <div style={{ marginTop: 16 }}>
            <SectionCard
                context="danger"
                title="Zona de perigo"
                subtitle="Desprovisionar ambiente remove definitivamente a infra dedicada (quando aplicável), cancela a assinatura no gateway (sem reembolso, sem credit note — o mês corrente já pago permanece, apenas a próxima fatura não é emitida) e faz a deleção dos registros SaaS. O banco de dados do contratante é preservado por 30 dias — depois é deletado permanentemente."
            >
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        {/* "Desprovisionar ambiente" some quando já há desprovisionamento agendado/em execução. */}
                        {!isDeprovisioningInProgress && (
                            <Button
                                variant="contained"
                                startIcon={<DeleteForeverIcon />}
                                onClick={() => this.setState({ dangerDialogOpen: true })}
                                style={{
                                    backgroundColor: '#d32f2f',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    boxShadow: '0 2px 8px rgba(211,47,47,0.3)',
                                }}
                            >
                                Desprovisionar ambiente
                            </Button>
                        )}
                        {/* Botão "Forçar deleção" só aparece se já houver desprovisionamento solicitado/agendado.
                            É um acelerador, não uma porta direta de destruição. */}
                        {(this.state.deprovisioningStatus?.provisioningstatus === 'deprovisioning_scheduled'
                          || this.state.deprovisioningStatus?.dropstatus === 'pending') && (
                            <Button
                                variant="contained"
                                onClick={this.openForceDropDialog}
                                style={{
                                    backgroundColor: '#b71c1c',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    boxShadow: '0 2px 12px rgba(183,28,28,0.4)',
                                    border: '2px solid #7f0000',
                                }}
                            >
                                ⚠ Forçar deleção imediata (2FA)
                            </Button>
                        )}
                    </div>
            </SectionCard>
            </div>
        );
    }

    renderInvoicesTab() {
        const { invoices } = this.state;
        const intl = this.props.intl;

        return (
            <div style={{ marginTop: 16 }}>
                <SectionCard
                    context="receipt"
                    title="Faturas"
                    noPadding
                    actions={(
                        <>
                            {this.renderRefreshAction(this.refreshInvoicesTab, this.state.loading)}
                            <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />} onClick={this.handleOpenCreateInvoice}>
                                {intl.formatMessage({ id: "admin.invoice.manual.create" })}
                            </Button>
                        </>
                    )}
                >
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell style={{ fontWeight: 600 }}>Tipo</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.invoice.number" })}</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Status</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.invoice.value" })}</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.invoice.date" })}</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.invoice.due.date" })}</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.invoice.actions" })}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoices.length === 0 ? (
                                <TableRow><TableCell colSpan={7} align="center">{intl.formatMessage({ id: "rows.show" })}</TableCell></TableRow>
                            ) : (
                                invoices.map((inv, idx) => {
                                    const isManual = !inv.gatewayinvoiceid;
                                    const isUnpaid = !inv.paidinvoice && inv.status !== 'paid' && inv.status !== 'void';
                                    return (
                                        <TableRow key={inv.id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                            <TableCell>
                                                <Chip label={`${inv.invoicetype === 'subscription' ? 'Assinatura' : 'Avulso'}${inv.billinginterval ? ` (${inv.billinginterval === 'month' ? 'Mensal' : inv.billinginterval === 'year' ? 'Anual' : inv.billinginterval})` : ''}`} size="small"
                                                    style={{ backgroundColor: inv.invoicetype === 'subscription' ? '#e3f2fd' : '#fff3e0', fontSize: 11, fontWeight: 500 }} />
                                            </TableCell>
                                            <TableCell>
                                                {inv.invoicenumber || '-'}
                                                {isManual && <span style={{ fontSize: 10, marginLeft: 4, color: '#ff9800' }}>(manual)</span>}
                                            </TableCell>
                                            <TableCell>{inv.status || '-'}</TableCell>
                                            <TableCell>{inv.valueinvoice != null ? `${inv.currency || 'BRL'} ${Number(inv.valueinvoice).toFixed(2)}` : '-'}</TableCell>
                                            <TableCell>{inv.dateinvoice ? new Date(inv.dateinvoice).toLocaleDateString('pt-BR') : '-'}</TableCell>
                                            <TableCell>{inv.duedate ? new Date(inv.duedate).toLocaleDateString('pt-BR') : '-'}</TableCell>
                                            <TableCell>
                                                {inv.hostedinvoiceurl && (
                                                    <Tooltip title="Ver online">
                                                        <IconButton size="small" onClick={() => window.open(inv.hostedinvoiceurl, '_blank')}>
                                                            <OpenInNewIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                {inv.invoicepdfurl && (
                                                    <Tooltip title="Download PDF">
                                                        <IconButton size="small" onClick={() => window.open(inv.invoicepdfurl, '_blank')}>
                                                            <PictureAsPdfIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                {isManual && isUnpaid && (
                                                    <>
                                                        <Tooltip title={intl.formatMessage({ id: "admin.invoice.manual.mark.paid" })}>
                                                            <IconButton size="small" style={{ color: '#4caf50' }}
                                                                onClick={() => this.setState({ markPaidDialogOpen: true, markPaidInvoiceId: inv.id })}>
                                                                <CheckCircleIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={intl.formatMessage({ id: "admin.invoice.manual.cancel" })}>
                                                            <IconButton size="small" style={{ color: '#f44336' }}
                                                                onClick={() => this.setState({ cancelInvoiceDialogOpen: true, cancelInvoiceId: inv.id })}>
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {invoices.length > 0 && (
                    <Typography variant="caption" color="textSecondary" style={{ display: 'block', textAlign: 'right', padding: '8px 16px' }}>
                        {invoices.length} registro(s) — {invoices.filter(i => i.invoicetype === 'subscription').length} assinatura(s), {invoices.filter(i => i.invoicetype !== 'subscription').length} avulso(s)
                    </Typography>
                )}
                </SectionCard>
            </div>
        );
    }

    renderPaymentsTab() {
        const { payments } = this.state;
        const detail = this.state.detail || {};
        const intl = this.props.intl;
        const gwType = detail.paymentgatewaytype ?? detail.paymentGatewayType ?? '';
        const isGateway = gwType && gwType !== 'manual';

        return (
            <div style={{ marginTop: 16 }}>
                <SectionCard
                    context="payment"
                    title="Pagamentos"
                    noPadding
                    actions={(
                        <>
                            {this.renderRefreshAction(this.refreshPaymentsTab, this.state.loading)}
                            {isGateway && <Button variant="outlined" color="primary" size="small" onClick={this.handleSyncPayments}>Sincronizar Gateway</Button>}
                            <Button variant="contained" color="primary" size="small" onClick={this.handleChargeSubscription}>Cobrar Agora</Button>
                        </>
                    )}
                >
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell style={{ fontWeight: 600 }}>Tipo</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.payment.value" })}</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.payment.date" })}</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Status</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Fatura</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>Gateway Ref</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.payment.failure" })}</TableCell>
                                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.invoice.actions" })}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments.length === 0 ? (
                                <TableRow><TableCell colSpan={8} align="center">{intl.formatMessage({ id: "rows.show" })}</TableCell></TableRow>
                            ) : (
                                payments.map((pay, idx) => (
                                    <TableRow key={pay.id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                        <TableCell>
                                            <Chip label={`${pay.invoicetype === 'subscription' ? 'Assinatura' : 'Avulso'}${pay.billinginterval ? ` (${pay.billinginterval === 'month' ? 'Mensal' : pay.billinginterval === 'year' ? 'Anual' : pay.billinginterval})` : ''}`} size="small"
                                                style={{ backgroundColor: pay.invoicetype === 'subscription' ? '#e3f2fd' : '#fff3e0', fontSize: 11, fontWeight: 500 }} />
                                        </TableCell>
                                        <TableCell>{pay.value != null ? `${pay.currency || 'BRL'} ${Number(pay.value).toFixed(2)}` : '-'}</TableCell>
                                        <TableCell>{pay.paymentdate ? new Date(pay.paymentdate).toLocaleDateString('pt-BR') : '-'}</TableCell>
                                        <TableCell><PaymentStatusBadge statusId={pay.paymentstatusid} /></TableCell>
                                        <TableCell style={{ fontSize: 11 }}>{pay.invoicenumber || '-'}</TableCell>
                                        <TableCell style={{ fontSize: 11 }}>{pay.gatewayreference || '-'}</TableCell>
                                        <TableCell style={{ fontSize: 11, color: '#f44336' }}>{pay.failuremessage || '-'}</TableCell>
                                        <TableCell>
                                            <div style={{ display: 'flex', gap: 4 }}>
                                                {pay.paymentstatusid === 2 && (
                                                    <Tooltip title={intl.formatMessage({ id: "admin.billing.retry" })}>
                                                        <IconButton size="small" onClick={() => this.handleRetryPayment(pay.id)}>
                                                            <RefreshIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                <Tooltip title="Excluir pagamento">
                                                    <IconButton size="small" onClick={() => this.handleVoidPayment(pay.id)} style={{ color: '#f44336' }}>
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {payments.length > 0 && (
                    <Typography variant="caption" color="textSecondary" style={{ display: 'block', textAlign: 'right', padding: '8px 16px' }}>
                        {payments.length} registro(s) — {payments.filter(p => p.invoicetype === 'subscription').length} assinatura(s), {payments.filter(p => p.invoicetype !== 'subscription').length} avulso(s)
                    </Typography>
                )}
                </SectionCard>
            </div>
        );
    }

    getEventTypeLabel(eventType) {
        const labels = {
            'subscription_event': 'Evento de Assinatura',
            'plan_change': 'Mudanca de Plano',
            'payment': 'Pagamento',
            'admin_block': 'Bloqueio Admin',
            'admin_unblock': 'Desbloqueio Admin',
            'admin_status_change': 'Alteracao de Status',
            'checkout_completed': 'Checkout Concluido',
        };
        return labels[eventType] || eventType || '-';
    }

    getEventTypeColor(eventType) {
        const colors = {
            'subscription_event': { bg: '#e3f2fd', color: '#1565c0' },
            'plan_change': { bg: '#f3e5f5', color: '#7b1fa2' },
            'payment': { bg: '#e8f5e9', color: '#2e7d32' },
            'admin_block': { bg: '#fff3e0', color: '#e65100' },
            'admin_unblock': { bg: '#e8f5e9', color: '#2e7d32' },
            'admin_status_change': { bg: '#e3f2fd', color: '#1565c0' },
            'checkout_completed': { bg: '#e8f5e9', color: '#2e7d32' },
        };
        return colors[eventType] || { bg: '#f5f5f5', color: '#616161' };
    }

    renderHistoryTab() {
        const { history } = this.state;
        const intl = this.props.intl;

        return (
            <div style={{ marginTop: 16 }}>
                <SectionCard
                    context="history"
                    title={intl.formatMessage({ id: "admin.tab.history" })}
                    subtitle="Eventos de assinatura, mudancas de plano e pagamentos"
                    noPadding
                    actions={this.renderRefreshAction(this.refreshHistoryTab, this.state.loading)}
                >
                    {history.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: 40, color: '#9e9e9e' }}>
                            <Typography variant="body1">{intl.formatMessage({ id: "rows.show" })}</Typography>
                        </div>
                    ) : (
                        <div style={{ padding: '8px 0' }}>
                            {history.map((evt, idx) => {
                                const evtType = evt.eventtype || evt.description || '-';
                                const typeColors = this.getEventTypeColor(evtType);
                                const evtDate = evt.eventdate;
                                return (
                                    <div key={idx} style={{
                                        backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        padding: '12px 20px',
                                        borderBottom: idx < history.length - 1 ? '1px solid #f0f0f0' : 'none',
                                        transition: 'background-color 0.15s',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                    >
                                        {/* Timeline dot */}
                                        <div style={{
                                            width: 10, height: 10, borderRadius: '50%',
                                            backgroundColor: typeColors.color,
                                            marginTop: 6, marginRight: 16, flexShrink: 0,
                                        }} />

                                        {/* Content */}
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                                                <span style={{
                                                    display: 'inline-block',
                                                    padding: '2px 10px',
                                                    borderRadius: 12,
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                    backgroundColor: typeColors.bg,
                                                    color: typeColors.color,
                                                }}>
                                                    {this.getEventTypeLabel(evtType)}
                                                </span>
                                                {evt.description && evt.description !== evtType && (
                                                    <Typography variant="body2" style={{ color: '#424242' }}>
                                                        {evt.description}
                                                    </Typography>
                                                )}
                                            </div>

                                            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 4 }}>
                                                {(evt.oldstatus || evt.newstatus) && (
                                                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 13 }}>
                                                        Status: <strong>{evt.oldstatus || '-'}</strong> &rarr; <strong>{evt.newstatus || '-'}</strong>
                                                    </Typography>
                                                )}
                                                {(evt.oldplan || evt.newplan) && (
                                                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 13 }}>
                                                        Plano: <strong>{evt.oldplan || '-'}</strong> &rarr; <strong>{evt.newplan || '-'}</strong>
                                                    </Typography>
                                                )}
                                                {evt.amount != null && (
                                                    <Typography variant="body2" style={{ fontSize: 13, fontWeight: 600, color: '#2e7d32' }}>
                                                        R$ {evt.amount.toFixed(2)}
                                                        {evt.paymentstatus && (
                                                            <span style={{
                                                                marginLeft: 6, padding: '1px 6px', borderRadius: 4, fontSize: 11,
                                                                backgroundColor: evt.paymentstatus === 'Pago' ? '#e8f5e9' : '#fef2f2',
                                                                color: evt.paymentstatus === 'Pago' ? '#2e7d32' : '#dc2626',
                                                            }}>
                                                                {evt.paymentstatus}
                                                            </span>
                                                        )}
                                                    </Typography>
                                                )}
                                                {evt.changedby && (
                                                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
                                                        Por: {evt.changedby}
                                                    </Typography>
                                                )}
                                            </div>

                                            {evt.metadata && (
                                                <Typography variant="caption" style={{
                                                    display: 'block', marginTop: 4,
                                                    color: '#9e9e9e', fontSize: 11,
                                                    maxWidth: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                                }}>
                                                    {evt.metadata}
                                                </Typography>
                                            )}
                                        </div>

                                        {/* Date */}
                                        <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: 16 }}>
                                            <Typography variant="body2" style={{ fontSize: 12, color: '#757575', whiteSpace: 'nowrap' }}>
                                                {evtDate ? new Date(evtDate).toLocaleDateString('pt-BR') : '-'}
                                            </Typography>
                                            <Typography variant="caption" style={{ color: '#9e9e9e' }}>
                                                {evtDate ? new Date(evtDate).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''}
                                            </Typography>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </SectionCard>
            </div>
        );
    }

    getCardBrandLabel(brand) {
        if (!brand) return 'Card';
        const brands = { visa: 'Visa', mastercard: 'Mastercard', amex: 'Amex', elo: 'Elo', discover: 'Discover', diners: 'Diners' };
        return brands[brand.toLowerCase()] || brand;
    }

    renderPaymentMethodsTab() {
        const { paymentMethods, loadingPaymentMethods } = this.state;
        const intl = this.props.intl;

        return (
            <div style={{ marginTop: 16 }}>
                <SectionCard
                    context="payment"
                    title={intl.formatMessage({ id: "admin.tab.payment.methods" })}
                    actions={this.renderRefreshAction(this.refreshPaymentMethodsTab, loadingPaymentMethods)}
                >
                    {loadingPaymentMethods ? (
                        <div style={{ textAlign: 'center', padding: 40 }}>
                            <CircularProgress size={32} />
                            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                                {intl.formatMessage({ id: "loading" })}
                            </Typography>
                        </div>
                    ) : paymentMethods.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: 40, color: '#9e9e9e' }}>
                            <PaymentIcon style={{ fontSize: 48, marginBottom: 8 }} />
                            <Typography variant="body1">{intl.formatMessage({ id: "admin.payment.methods.empty" })}</Typography>
                        </div>
                    ) : (
                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 700, fontSize: '0.8rem', color: '#424242', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '2px solid #9e9e9e' }}>
                                        <TableCell>{intl.formatMessage({ id: "admin.payment.method.brand" })}</TableCell>
                                        <TableCell>{intl.formatMessage({ id: "admin.payment.method.last4" })}</TableCell>
                                        <TableCell>{intl.formatMessage({ id: "admin.payment.method.expiry" })}</TableCell>
                                        <TableCell>{intl.formatMessage({ id: "admin.payment.method.default" })}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paymentMethods.map((pm, idx) => (
                                        <TableRow key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <PaymentIcon style={{ fontSize: 20, color: '#757575' }} />
                                                    {this.getCardBrandLabel(pm.cardbrand || pm.cardBrand)}
                                                </div>
                                            </TableCell>
                                            <TableCell>**** {pm.cardlast4 || pm.cardLast4 || '-'}</TableCell>
                                            <TableCell>{(pm.cardexpmonth || pm.cardExpMonth || '--')}/{(pm.cardexpyear || pm.cardExpYear || '--')}</TableCell>
                                            <TableCell>
                                                {(pm.isdefault || pm.isDefault) ? (
                                                    <span style={{ padding: '2px 8px', borderRadius: 12, fontSize: 12, fontWeight: 600, backgroundColor: '#e8f5e9', color: '#2e7d32' }}>
                                                        Default
                                                    </span>
                                                ) : '-'}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </SectionCard>
            </div>
        );
    }

    renderCreditsTab() {
        const { creditBalances, creditTransactions } = this.state;
        const intl = this.props.intl;

        const formatCurrency = (v) => v != null ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v) : '-';

        const transactionTypeLabels = {
            'monthly_credit': 'Crédito Mensal',
            'purchase': 'Compra',
            'consumption': 'Consumo',
            'auto_recharge': 'Recarga Automática'
        };

        return (
            <Grid container spacing={3} style={{ marginTop: 0 }}>
                {/* Balances */}
                <Grid item xs={12}>
                <SectionCard
                    context="success"
                    title={intl.formatMessage({ id: "admin.credits.balances" })}
                    actions={this.renderRefreshAction(this.refreshCreditsTab, this.state.loading)}
                >
                {creditBalances.length === 0 ? (
                    <Typography variant="body2" color="textSecondary" style={{ padding: 16 }}>
                        {intl.formatMessage({ id: "admin.credits.no.balances" })}
                    </Typography>
                ) : (
                    <Grid container spacing={2}>
                        {creditBalances.map((cb, idx) => {
                            const balance = cb.currentbalance ?? cb.currentBalance ?? 0;
                            const appName = cb.applicationname ?? cb.applicationName ?? '-';
                            const consumed = cb.totalconsumed ?? cb.totalConsumed ?? 0;
                            const purchased = cb.totalpurchased ?? cb.totalPurchased ?? 0;
                            const cppId = cb.contractplanperiodicityid ?? cb.contractPlanPeriodicityId;
                            return (
                                <Grid item xs={12} sm={6} md={4} key={idx}>
                                    <SectionCard context={balance > 0 ? "success" : "danger"} title={appName} divider={false}>
                                            <Typography variant="h5" style={{ fontWeight: 700, color: balance > 0 ? '#2e7d32' : '#c62828', marginTop: 4 }}>
                                                {formatCurrency(balance)}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                                                {intl.formatMessage({ id: "admin.credits.purchased" })}: {formatCurrency(purchased)}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                                                {intl.formatMessage({ id: "admin.credits.consumed" })}: {formatCurrency(consumed)}
                                            </Typography>
                                            <Divider style={{ margin: '8px 0' }} />
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                <TextField
                                                    label="R$"
                                                    type="number"
                                                    size="small"
                                                    variant="outlined"
                                                    value={this.state.creditPurchaseCppId === cppId ? this.state.creditPurchaseAmount : ''}
                                                    onChange={(e) => {
                                                        this.setState({ creditPurchaseAmount: e.target.value, creditPurchaseCppId: cppId });
                                                        if (this.state.creditPaymentMethods.length === 0) {
                                                            adminBillingService.getCreditPaymentMethods(cppId).then(res => {
                                                                if (res.data && res.data.success) {
                                                                    const methods = res.data.data || [];
                                                                    this.setState({
                                                                        creditPaymentMethods: methods,
                                                                        creditSelectedPaymentMethodId: methods.length === 1 ? String(methods[0].id) : ''
                                                                    });
                                                                }
                                                            });
                                                        }
                                                    }}
                                                    inputProps={{ step: '0.01', min: '0' }}
                                                    style={{ width: '100%' }}
                                                />
                                                {this.state.creditPurchaseCppId === cppId && this.state.creditPaymentMethods.length > 0 && (
                                                    <TextField
                                                        select
                                                        label={intl.formatMessage({ id: "admin.credits.payment.method" })}
                                                        size="small"
                                                        variant="outlined"
                                                        value={this.state.creditSelectedPaymentMethodId}
                                                        onChange={(e) => this.setState({ creditSelectedPaymentMethodId: e.target.value })}
                                                        SelectProps={{ native: true }}
                                                        InputLabelProps={{ shrink: true }}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <option value="">Selecione...</option>
                                                        {this.state.creditPaymentMethods.map(pm => (
                                                            <option key={pm.id} value={pm.id}>{pm.name}</option>
                                                        ))}
                                                    </TextField>
                                                )}
                                                <Button
                                                    variant="contained" size="small"
                                                    disabled={this.state.creditPurchaseLoading || !this.state.creditPurchaseAmount || this.state.creditPurchaseCppId !== cppId || (this.state.creditPaymentMethods.length > 0 && !this.state.creditSelectedPaymentMethodId)}
                                                    onClick={() => this.setState({ creditPurchaseConfirmOpen: true, creditPurchaseConfirmCppId: cppId })}
                                                    style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none' }}
                                                >
                                                    {this.state.creditPurchaseLoading && this.state.creditPurchaseCppId === cppId
                                                        ? <CircularProgress size={18} style={{ color: '#fff' }} />
                                                        : intl.formatMessage({ id: "admin.credits.add" })
                                                    }
                                                </Button>
                                            </div>
                                    </SectionCard>
                                </Grid>
                            );
                        })}
                    </Grid>
                )}
                </SectionCard>
                </Grid>

                {/* Transactions */}
                <Grid item xs={12}>
                <SectionCard
                    context="history"
                    title={intl.formatMessage({ id: "admin.credits.transactions" })}
                >
                {creditTransactions.length === 0 ? (
                    <Typography variant="body2" color="textSecondary" style={{ padding: 16 }}>
                        {intl.formatMessage({ id: "admin.credits.no.transactions" })}
                    </Typography>
                ) : (
                    <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.credits.date" })}</TableCell>
                                    <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.credits.type" })}</TableCell>
                                    <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.credits.description" })}</TableCell>
                                    <TableCell align="right" style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.credits.amount" })}</TableCell>
                                    <TableCell align="right" style={{ fontWeight: 600 }}>{intl.formatMessage({ id: "admin.credits.balance.after" })}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {creditTransactions.map((ct, idx) => {
                                    const amount = ct.amount ?? 0;
                                    const type = ct.transactiontype ?? ct.transactionType ?? '';
                                    const date = ct.createdat ?? ct.createdAt;
                                    return (
                                        <TableRow key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                            <TableCell>{date ? new Date(date).toLocaleString('pt-BR') : '-'}</TableCell>
                                            <TableCell>
                                                <Chip label={transactionTypeLabels[type] || type} size="small"
                                                    style={{ backgroundColor: amount >= 0 ? '#e8f5e9' : '#ffebee', color: amount >= 0 ? '#2e7d32' : '#c62828' }} />
                                            </TableCell>
                                            <TableCell>{ct.description ?? '-'}</TableCell>
                                            <TableCell align="right" style={{ fontWeight: 600, color: amount >= 0 ? '#2e7d32' : '#c62828' }}>
                                                {amount >= 0 ? '+' : ''}{formatCurrency(amount)}
                                            </TableCell>
                                            <TableCell align="right">{formatCurrency(ct.balanceafter ?? ct.balanceAfter)}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                </SectionCard>
                </Grid>
            </Grid>
        );
    }

    renderUsageTab() {
        const { usage } = this.state;
        const intl = this.props.intl;

        return (
            <div style={{ marginTop: 16 }}>
                <SectionCard
                    context="search"
                    title={intl.formatMessage({ id: "admin.tab.usage" })}
                    subtitle={intl.formatMessage({ id: "admin.usage.description" })}
                    noPadding
                    actions={this.renderRefreshAction(this.refreshUsageTab, this.state.loading)}
                >
                    {usage.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: 40, color: '#9e9e9e' }}>
                            <Typography variant="body1">{intl.formatMessage({ id: "admin.usage.empty" })}</Typography>
                        </div>
                    ) : (
                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 700, fontSize: '0.8rem', color: '#424242', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '2px solid #9e9e9e' }}>
                                        <TableCell>{intl.formatMessage({ id: "admin.contract.products.product" })}</TableCell>
                                        <TableCell>{intl.formatMessage({ id: "admin.usage.type" })}</TableCell>
                                        <TableCell align="right">{intl.formatMessage({ id: "admin.usage.quantity" })}</TableCell>
                                        <TableCell align="right">{intl.formatMessage({ id: "admin.usage.included" })}</TableCell>
                                        <TableCell align="right">{intl.formatMessage({ id: "admin.usage.overage" })}</TableCell>
                                        <TableCell align="right">{intl.formatMessage({ id: "admin.usage.unit.value" })}</TableCell>
                                        <TableCell align="right">{intl.formatMessage({ id: "admin.usage.overage.total" })}</TableCell>
                                        <TableCell>{intl.formatMessage({ id: "admin.usage.reported" })}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {usage.map((row, idx) => {
                                        const hasOverage = row.overagequantity > 0;
                                        return (
                                            <TableRow key={idx} style={{ backgroundColor: hasOverage ? '#fff8e1' : (idx % 2 === 0 ? '#fff' : '#fafafa') }}>
                                                <TableCell>
                                                    {(() => {
                                                        const ppId = row.planperiodicityid ?? row.planPeriodicityId;
                                                        if (!ppId) return <span style={{ color: '#9e9e9e' }}>Geral</span>;
                                                        const prod = (this.state.contractProducts || []).find(p => (p.planperiodicityid ?? p.planPeriodicityId) === ppId);
                                                        return prod ? (prod.applicationname ?? prod.applicationName ?? '-') : `PP #${ppId}`;
                                                    })()}
                                                </TableCell>
                                                <TableCell>
                                                    <strong>{this.getUsageTypeLabel(row.usagetype)}</strong>
                                                </TableCell>
                                                <TableCell align="right">{Number(row.quantity).toLocaleString('pt-BR')}</TableCell>
                                                <TableCell align="right">{Number(row.includedquantity).toLocaleString('pt-BR')}</TableCell>
                                                <TableCell align="right">
                                                    {hasOverage ? (
                                                        <span style={{ color: '#e65100', fontWeight: 600 }}>
                                                            {Number(row.overagequantity).toLocaleString('pt-BR')}
                                                        </span>
                                                    ) : '0'}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.unitvalue > 0 ? `R$ ${Number(row.unitvalue).toFixed(2)}` : '-'}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.overagetotal > 0 ? (
                                                        <span style={{ color: '#c62828', fontWeight: 600 }}>
                                                            R$ {Number(row.overagetotal).toFixed(2)}
                                                        </span>
                                                    ) : 'R$ 0,00'}
                                                </TableCell>
                                                <TableCell>
                                                    {row.reportedat ? new Date(row.reportedat).toLocaleString('pt-BR') : '-'}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </SectionCard>
            </div>
        );
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;
        const { detail } = this.state;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='lg' style={{ paddingLeft: 24 }}>
                        <CssBaseline />

                        {/* Back */}
                        <div style={{ marginBottom: 8 }}>
                            <Button
                                variant="text"
                                color="primary"
                                startIcon={<ArrowBackIcon />}
                                onClick={() => this.props.history.push(`/${this.props.match.params.lang}/admin-subscriptions`)}
                            >
                                {intl.formatMessage({ id: "back" })}
                            </Button>
                        </div>

                        <Typography variant="h5" style={{ marginBottom: 16 }}>
                            {intl.formatMessage({ id: "admin.subscription.detail" })}
                        </Typography>

                        <Tabs value={this.state.tabValue} onChange={this.handleTabChange} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto">
                            <Tab label={intl.formatMessage({ id: "admin.tab.summary" })} />
                            <Tab label={intl.formatMessage({ id: "admin.tab.invoices" })} />
                            <Tab label={intl.formatMessage({ id: "admin.tab.payments" })} />
                            <Tab label={intl.formatMessage({ id: "admin.tab.history" })} />
                            <Tab label={intl.formatMessage({ id: "admin.tab.payment.methods" })} />
                            <Tab label={intl.formatMessage({ id: "admin.tab.usage" })} />
                            <Tab label={intl.formatMessage({ id: "admin.tab.credits" })} />
                            <Tab label="Provisionamento" />
                            <Tab label="Outras Informações" />
                            <Tab label="Histórico de Status" />
                        </Tabs>

                        <DeprovisioningBanner
                            status={this.state.deprovisioningStatus}
                            onAbortDeprovisioning={this.handleAbortDeprovisioning}
                            onAbortDatabaseDrop={this.handleAbortDatabaseDrop}
                            aborting={this.state.aborting}
                        />

                        {this.state.tabValue === 0 && (
                            <>
                                {this.renderSummaryTab()}
                                {this.renderDangerZone()}
                            </>
                        )}
                        {this.state.tabValue === 1 && this.renderInvoicesTab()}
                        {this.state.tabValue === 2 && this.renderPaymentsTab()}
                        {this.state.tabValue === 3 && this.renderHistoryTab()}
                        {this.state.tabValue === 4 && this.renderPaymentMethodsTab()}
                        {this.state.tabValue === 5 && this.renderUsageTab()}
                        {this.state.tabValue === 6 && this.renderCreditsTab()}
                        {this.state.tabValue === 7 && this.renderProvisioningTab()}
                        {this.state.tabValue === 8 && this.renderHirerConfigTab()}
                        {this.state.tabValue === 9 && (
                            <StatusHistoryTable
                                items={this.state.statusHistory}
                                loading={this.state.statusHistoryLoading}
                                onRefresh={this.refreshStatusHistoryTab}
                            />
                        )}

                        {/* Convert Plan Dialog */}
                        {/* Convert to Trial Dialog */}
                        <ConfirmActionDialog
                            open={this.state.convertToTrialDialogOpen}
                            onClose={() => this.setState({ convertToTrialDialogOpen: false })}
                            onConfirm={this.handleConvertToTrialConfirm}
                            title="Converter para Trial"
                            message="Deseja converter esta assinatura para o modo Trial? Todos os produtos serao migrados para o plano Trial."
                            description={detail ? `Contratante: ${detail.name} (${detail.workspace})` : ''}
                            confirmLabel="Sim, Converter para Trial"
                            confirmColor="#2196f3"
                            iconColor="#2196f3"
                        >
                            <TextField
                                label="Duracao do Trial"
                                select
                                value={this.state.trialDays}
                                onChange={(e) => this.setState({ trialDays: e.target.value })}
                                fullWidth
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                                style={{ marginTop: 8 }}
                            >
                                <option value={7}>7 dias</option>
                                <option value={14}>14 dias</option>
                                <option value={30}>30 dias</option>
                            </TextField>
                        </ConfirmActionDialog>

                        {/* Switch Product Plan Dialog */}
                        <Dialog open={this.state.switchPlanDialogOpen} onClose={() => this.setState({ switchPlanDialogOpen: false })} maxWidth="md" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>Converter Plano - {this.state.selectedProductForSwitch?.applicationname}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ switchPlanDialogOpen: false })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ minHeight: 300, padding: '16px 24px' }}>
                                {this.state.switchPlanStep === 0 && (
                                    <div>
                                        <Typography variant="subtitle1" style={{ marginBottom: 12, fontWeight: 600 }}>Selecione o novo plano:</Typography>
                                        {this.state.switchPlansLoading ? <CircularProgress size={24} /> : (
                                            <Grid container spacing={2}>
                                                {this.state.switchPlans.map(plan => {
                                                    const sel = this.state.switchSelectedPlanId === plan.id;
                                                    return (
                                                        <Grid item xs={12} sm={4} key={plan.id}>
                                                            <Card onClick={() => this.handleSwitchPlanSelectPlan(plan.id)} style={{
                                                                cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #277afe' : '1px solid #e0e0e0',
                                                                backgroundColor: sel ? '#e3f2fd' : '#fff', textAlign: 'center', padding: 16
                                                            }}>
                                                                <Typography variant="h6" style={{ fontWeight: 600 }}>{plan.name}</Typography>
                                                                <Chip label={plan.isShared ? 'Compartilhado' : 'Dedicado'} size="small" style={{ marginTop: 8 }} />
                                                            </Card>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        )}
                                    </div>
                                )}
                                {this.state.switchPlanStep === 1 && (
                                    <div>
                                        <Typography variant="subtitle1" style={{ marginBottom: 12, fontWeight: 600 }}>Selecione a periodicidade:</Typography>
                                        {this.state.switchPeriodicitiesLoading ? <CircularProgress size={24} /> : (
                                            <Grid container spacing={2}>
                                                {this.state.switchPeriodicities.map(pp => {
                                                    const sel = this.state.switchSelectedPpId === pp.id;
                                                    return (
                                                        <Grid item xs={12} sm={4} key={pp.id}>
                                                            <Card onClick={() => this.setState({ switchSelectedPpId: pp.id })} style={{
                                                                cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #ff9800' : '1px solid #e0e0e0',
                                                                backgroundColor: sel ? '#fff3e0' : '#fff', textAlign: 'center', padding: 16
                                                            }}>
                                                                <Typography variant="body1" style={{ fontWeight: 500 }}>{pp.periodicityname ?? pp.periodicityName}</Typography>
                                                                <Typography variant="h6" style={{ color: '#ff9800', fontWeight: 700 }}>R$ {Number(pp.planvaluepermonth ?? pp.planValuePerMonth ?? 0).toFixed(2)}</Typography>
                                                            </Card>
                                                        </Grid>
                                                    );
                                                })}
                                                {this.state.switchPeriodicities.length === 0 && <Typography color="textSecondary" style={{ padding: 16 }}>Nenhuma periodicidade disponivel para este plano.</Typography>}
                                            </Grid>
                                        )}
                                    </div>
                                )}
                                {this.state.switchPlanStep === 2 && (
                                    <div>
                                        <Typography variant="subtitle1" style={{ marginBottom: 12, fontWeight: 600 }}>Resumo da alteracao:</Typography>
                                        <Typography variant="body2"><strong>Produto:</strong> {this.state.selectedProductForSwitch?.applicationname}</Typography>
                                        <Typography variant="body2"><strong>Plano atual:</strong> {this.state.selectedProductForSwitch?.planname} ({this.state.selectedProductForSwitch?.periodicityname})</Typography>
                                        <Typography variant="body2"><strong>Novo plano:</strong> {this.state.switchPlans.find(p => p.id === this.state.switchSelectedPlanId)?.name} - {this.state.switchPeriodicities.find(p => p.id === this.state.switchSelectedPpId)?.periodicityname ?? this.state.switchPeriodicities.find(p => p.id === this.state.switchSelectedPpId)?.periodicityName}</Typography>
                                        <Divider style={{ margin: '12px 0' }} />
                                        <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>Os valores e limites serao atualizados conforme o novo plano selecionado.</Typography>
                                    </div>
                                )}
                            </DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ switchPlanDialogOpen: false })} style={{ textTransform: 'none', fontWeight: 500 }}>Cancelar</Button>
                                {this.state.switchPlanStep > 0 && <Button onClick={() => this.setState(prev => ({ switchPlanStep: prev.switchPlanStep - 1 }))} style={{ textTransform: 'none', fontWeight: 500 }}>Voltar</Button>}
                                {this.state.switchPlanStep < 2 && (
                                    <Button variant="contained" color="primary"
                                        disabled={(this.state.switchPlanStep === 0 && !this.state.switchSelectedPlanId) || (this.state.switchPlanStep === 1 && !this.state.switchSelectedPpId)}
                                        onClick={() => this.setState(prev => ({ switchPlanStep: prev.switchPlanStep + 1 }))}
                                        style={{ textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>
                                        Proximo
                                    </Button>
                                )}
                                {this.state.switchPlanStep === 2 && (
                                    <Button variant="contained" color="primary" onClick={this.handleSwitchPlanConfirm} style={{ textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>Confirmar</Button>
                                )}
                            </div>
                        </Dialog>

                        {/* Block Hirer Dialog */}
                        <ConfirmActionDialog
                            open={this.state.blockDialogOpen}
                            onClose={() => this.setState({ blockDialogOpen: false })}
                            onConfirm={this.handleBlockConfirm}
                            title={intl.formatMessage({ id: "admin.block.dialog.title" })}
                            message={intl.formatMessage({ id: "admin.block.dialog.message" })}
                            description={detail ? intl.formatMessage({ id: "admin.block.dialog.description" }, { name: detail.name }) : ''}
                            confirmLabel={intl.formatMessage({ id: "admin.block.dialog.confirm" })}
                            cancelLabel={intl.formatMessage({ id: "back" })}
                            confirmColor="#ff9800"
                            icon={BlockIcon}
                            iconColor="#ff9800"
                        />

                        {/* Credit Purchase Confirmation */}
                        <Dialog open={this.state.creditPurchaseConfirmOpen} onClose={() => this.setState({ creditPurchaseConfirmOpen: false })} maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{intl.formatMessage({ id: "admin.credits.purchase.confirm.title" })}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ creditPurchaseConfirmOpen: false })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '16px 24px' }}>
                                <Typography variant="body1">
                                    {intl.formatMessage({ id: "admin.credits.purchase.confirm.message" }, { amount: `R$ ${parseFloat(this.state.creditPurchaseAmount || 0).toFixed(2)}` })}
                                </Typography>
                            </DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ creditPurchaseConfirmOpen: false })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button variant="contained" onClick={this.handleAdminPurchaseCredits} disabled={this.state.creditPurchaseLoading}
                                    style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>
                                    {this.state.creditPurchaseLoading ? <CircularProgress size={20} style={{ color: '#fff' }} /> : intl.formatMessage({ id: "confirm" })}
                                </Button>
                            </div>
                        </Dialog>

                        {/* Add Product Wizard */}
                        <AddProductWizard
                            open={this.state.addProductDialogOpen}
                            onClose={() => this.setState({ addProductDialogOpen: false })}
                            onConfirm={this.handleAddProductConfirm}
                            hirerId={detail ? detail.hirerid : null}
                            hirerName={detail ? detail.name : ''}
                            contractProducts={this.state.contractProducts}
                            intl={intl}
                        />

                        {/* Remove Product Confirmation Dialog */}
                        <ConfirmActionDialog
                            open={this.state.removeProductDialogOpen}
                            onClose={() => this.setState({ removeProductDialogOpen: false, removeProductId: null })}
                            onConfirm={this.handleRemoveProductConfirm}
                            title={intl.formatMessage({ id: "admin.contract.products.remove" })}
                            message={intl.formatMessage({ id: "admin.contract.products.remove.confirm" })}
                            confirmLabel={intl.formatMessage({ id: "confirm" })}
                            cancelLabel={intl.formatMessage({ id: "back" })}
                            confirmColor="#e53935"
                            icon={BlockIcon}
                            iconColor="#e53935"
                        />

                        {/* Create Manual Invoice Dialog */}
                        <Dialog
                            open={this.state.createInvoiceDialogOpen}
                            onClose={() => this.setState({ createInvoiceDialogOpen: false })}
                            maxWidth="sm"
                            fullWidth
                        >
                            <DialogTitle>{intl.formatMessage({ id: "admin.invoice.manual.create" })}</DialogTitle>
                            <DialogContent>
                                <Grid container spacing={2} style={{ marginTop: 4 }}>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.invoice.manual.value" })}
                                            type="number"
                                            value={this.state.newInvoice.value}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, value: e.target.value } })}
                                            fullWidth
                                            required
                                            inputProps={{ min: 0, step: 0.01 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.invoice.manual.month" })}
                                            type="number"
                                            value={this.state.newInvoice.monthReference}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, monthReference: e.target.value } })}
                                            fullWidth
                                            inputProps={{ min: 1, max: 12 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.invoice.manual.year" })}
                                            type="number"
                                            value={this.state.newInvoice.yearReference}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, yearReference: e.target.value } })}
                                            fullWidth
                                            inputProps={{ min: 2020 }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.invoice.manual.due.date" })}
                                            type="date"
                                            value={this.state.newInvoice.dueDate}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, dueDate: e.target.value } })}
                                            fullWidth
                                            required
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            select
                                            label={intl.formatMessage({ id: "admin.invoice.manual.payment.method" })}
                                            value={this.state.newInvoice.paymentMethodId}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, paymentMethodId: e.target.value } })}
                                            fullWidth
                                            SelectProps={{ native: true }}
                                            InputLabelProps={{ shrink: true }}
                                        >
                                            <option value="">-</option>
                                            {this.state.invoicePaymentMethods.map(pm => (
                                                <option key={pm.id} value={pm.id}>{pm.name}</option>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.invoice.manual.discount" })}
                                            type="number"
                                            value={this.state.newInvoice.discountValue}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, discountValue: e.target.value } })}
                                            fullWidth
                                            inputProps={{ min: 0, step: 0.01 }}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.invoice.manual.interest" })}
                                            type="number"
                                            value={this.state.newInvoice.interestValue}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, interestValue: e.target.value } })}
                                            fullWidth
                                            inputProps={{ min: 0, step: 0.01 }}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label={intl.formatMessage({ id: "admin.invoice.manual.fine" })}
                                            type="number"
                                            value={this.state.newInvoice.fineValue}
                                            onChange={(e) => this.setState({ newInvoice: { ...this.state.newInvoice, fineValue: e.target.value } })}
                                            fullWidth
                                            inputProps={{ min: 0, step: 0.01 }}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ createInvoiceDialogOpen: false })} color="default">
                                    {intl.formatMessage({ id: "back" })}
                                </Button>
                                <Button onClick={this.handleCreateInvoice} color="primary" variant="contained">
                                    {intl.formatMessage({ id: "admin.invoice.manual.create" })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Mark Invoice as Paid Dialog */}
                        <ConfirmActionDialog
                            open={this.state.markPaidDialogOpen}
                            onClose={() => this.setState({ markPaidDialogOpen: false, markPaidInvoiceId: null })}
                            onConfirm={this.handleMarkInvoicePaid}
                            title={intl.formatMessage({ id: "admin.invoice.manual.mark.paid" })}
                            message={intl.formatMessage({ id: "admin.invoice.manual.mark.paid.confirm" })}
                            confirmLabel={intl.formatMessage({ id: "confirm" })}
                            cancelLabel={intl.formatMessage({ id: "back" })}
                            confirmColor="#4caf50"
                            icon={CheckCircleIcon}
                            iconColor="#4caf50"
                        />

                        {/* Cancel Invoice Dialog */}
                        <ConfirmActionDialog
                            open={this.state.cancelInvoiceDialogOpen}
                            onClose={() => this.setState({ cancelInvoiceDialogOpen: false, cancelInvoiceId: null })}
                            onConfirm={this.handleCancelInvoice}
                            title={intl.formatMessage({ id: "admin.invoice.manual.cancel" })}
                            message={intl.formatMessage({ id: "admin.invoice.manual.cancel.confirm" })}
                            confirmLabel={intl.formatMessage({ id: "confirm" })}
                            cancelLabel={intl.formatMessage({ id: "back" })}
                            confirmColor="#f44336"
                            icon={DeleteIcon}
                            iconColor="#f44336"
                        />

                        {/* Confirm Dialog (global - fora das abas) */}
                        <Dialog open={this.state.provisioningConfirmDialog.open} onClose={() => this.setState({ provisioningConfirmDialog: { open: false } })} maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{this.state.provisioningConfirmDialog.title}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ provisioningConfirmDialog: { open: false } })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '16px 24px' }}><Typography>{this.state.provisioningConfirmDialog.message}</Typography></DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ provisioningConfirmDialog: { open: false } })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button variant="contained" color="primary" onClick={this.state.provisioningConfirmDialog.action} style={{ textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>{intl.formatMessage({ id: "confirm" })}</Button>
                            </div>
                        </Dialog>

                        <ConfirmActionDialog open={this.state.abortConfirmOpen} onClose={() => this.setState({ abortConfirmOpen: false })} onConfirm={this.confirmAbortDeprovisioning} title="Abortar desprovisionamento" message="Tem certeza que deseja abortar o desprovisionamento agendado?" description="O ambiente voltará ao estado anterior (status, hirer, contrato) e o agendamento será cancelado. Apenas o registro do agendamento é desfeito; nenhum dado é perdido." confirmLabel="Abortar agora" cancelLabel="Voltar" confirmColor="#f57c00" iconColor="#f57c00" />
                        <ConfirmActionDialog open={this.state.abortDropConfirmOpen} onClose={() => this.setState({ abortDropConfirmOpen: false })} onConfirm={this.confirmAbortDatabaseDrop} title="Abortar deleção do banco de dados" message="Tem certeza que deseja abortar a deleção do banco de dados?" description="O banco de dados continuará preservado indefinidamente. O agendamento de deleção é cancelado." confirmLabel="Abortar deleção" cancelLabel="Voltar" confirmColor="#546e7a" iconColor="#546e7a" />

                        <DangerConfirmDialog
                            open={this.state.dangerDialogOpen}
                            onClose={() => this.setState({ dangerDialogOpen: false, dangerCodeSentState: null })}
                            onConfirm={this.handleScheduleDeprovisioning}
                            workspace={this.state.detail?.workspace || ''}
                            title="Desprovisionar ambiente"
                            message={this.state.detail ? `Agendar desprovisionamento de "${this.state.detail.name}" (${this.state.detail.workspace}).` : ''}
                            description="Após o período de carência, a infra será derrubada (K8s/EKS para dedicado), a assinatura no gateway será cancelada (sem reembolso), e os registros SaaS deletados. O banco de dados do contratante é preservado por 30 dias — depois, deletado permanentemente. Você pode abortar enquanto o desprovisionamento estiver agendado."
                            warningText="Essa ação não pode ser desfeita após o período de carência expirar."
                            confirmLabel="Agendar desprovisionamento"
                            loading={this.state.dangerLoading}
                            requireReason
                            requireTwoFactor
                            onSendCode={this.handleSendScheduleDeprovCode}
                            sendingCode={this.state.dangerSendingCode}
                            codeSentState={this.state.dangerCodeSentState}
                            defaultEmail={this.props.userSession?.user?.email || ''}
                        />

                        <ForceDropConfirmDialog
                            open={this.state.forceDropDialogOpen}
                            onClose={this.closeForceDropDialog}
                            workspace={this.state.detail?.workspace || ''}
                            defaultEmail={this.props.userSession?.user?.email || ''}
                            onSendCode={this.handleSendForceDropCode}
                            onConfirm={this.handleForceDatabaseDrop}
                            sending={this.state.forceDropSending}
                            submitting={this.state.forceDropSubmitting}
                            codeSentState={this.state.forceDropCodeSentState}
                            submitError={this.state.forceDropError}
                        />

                        <Dialog open={this.state.companySizeDialogOpen} onClose={this.closeCompanySizeDialog} maxWidth="xs" fullWidth>
                            <DialogTitle>{intl.formatMessage({ id: "admin.hirer.company_size.edit" })}</DialogTitle>
                            <DialogContent>
                                <TextField
                                    select
                                    SelectProps={{ native: true }}
                                    InputLabelProps={{ shrink: true }}
                                    label={intl.formatMessage({ id: "admin.hirer.company_size" })}
                                    value={this.state.companySizeDialogValue}
                                    onChange={(e) => this.setState({ companySizeDialogValue: e.target.value })}
                                    fullWidth
                                >
                                    <option value="">{intl.formatMessage({ id: "admin.hirer.company_size.placeholder" })}</option>
                                    {this.state.companySizes.map(cs => (
                                        <option key={cs.id} value={cs.id}>{cs.name}</option>
                                    ))}
                                </TextField>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.closeCompanySizeDialog} disabled={this.state.companySizeSaving}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button onClick={this.handleSaveCompanySize} variant="contained" color="primary" disabled={this.state.companySizeSaving}>{intl.formatMessage({ id: "save" })}</Button>
                            </DialogActions>
                        </Dialog>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminSubscriptionDetail.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    currentHirer: state.adminBilling.currentHirer,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminSubscriptionDetail)));
